export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "de-DE",
    "Messages": {
        "3": "3",
        "5": "5",
        "10": "10",
        "-": "-",
        "...nie znalazłeś treści? Utwórz nową.": "… keinen passenden Inhalt gefunden? Erstellen Sie einen neuen.",
        "{count} odpowiedzi": "{count} Antworten",
        "{seconds} sek.": "{seconds} Sek.",
        "1. Wybierz wzór": "1. Vorlage auswählen",
        "2 kolumny 25/75": "2 Spalten 25/75",
        "2 kolumny 33/66": "2 Spalten 33/66",
        "2 kolumny 50/50": "2 Spalten 50/50",
        "2 kolumny 66/33": "2 Spalten 66/33",
        "2 kolumny 75/25": "2 Spalten 75/25",
        "2. Wybierz wpis": "2. Eintrag auswählen",
        "3 kolumny": "3 Spalten",
        "3 kolumny 25/25/50": "3 Spalten 25/25/50",
        "3 kolumny 25/50/25": "3 Spalten 25/50/25",
        "3 kolumny 50/25/25": "3 Spalten 50/25/25",
        "3. Konfiguruj i wstaw": "3. Konfigurieren und einfügen",
        "4 kolumny": "4 Spalten",
        "A11y": "Barrierefreiheit",
        "A11y i SEO": "Barrierefreiheit und SEO",
        "Aby nastąpiła automatyczna akceptacja regulaminu, wybrana wersja musi mieć status „Do akceptacji”.": "Damit die Nutzungsbedingungen automatisch akzeptiert werden, muss die ausgewählte Version den Status „Zur Freigabe“ haben.",
        "Adres": "Adresse",
        "Adres docelowy": "Zieladresse",
        "Adres domenowy": "Domainadresse",
        "Adres domeny": "Domainadresse",
        "Adres e-mail": "E-Mail-Adresse",
        "Adres IP": "IP-Adresse",
        "Adres kanoniczny": "Kanonische Adresse",
        "Adres linku": "Linkadresse",
        "Adres otwierany po kliknięciu bannera.": "Adresse, die nach einem Klick auf das Banner geöffnet wird.",
        "Adres strony": "Seitenadresse",
        "Adres tematu oraz jego zasięg.": "Adresse des Themas und dessen Reichweite.",
        "Adres url": "URL-Adresse",
        "Adres URL": "URL-Adresse",
        "Adres url do pliku wideo": "URL des Videos",
        "Adres URL profilu autora.": "URL des Autorenprofils.",
        "Adres został skopiowany.": "Adresse wurde kopiert.",
        "Adres źródłowy": "Quelladresse",
        "Adresy w obrębie tej samej domeny podawaj jako pełne ścieżki, np. /stara-strona oraz /nowa-strona.": "Geben Sie Adressen innerhalb derselben Domain als vollständige Pfade an, z. B. /alte-seite und /neue-seite.",
        "Adresy witryny korzystają z HTTPS zamiast HTTP.": "Website-Adressen verwenden HTTPS statt HTTP.",
        "AI": "AI",
        "AI w wynikach Google Search": "AI in den Google-Suchergebnissen",
        "Akceptacja komentarzy": "Kommentarfreigabe",
        "Akceptuj": "Akzeptieren",
        "Akcje ceny": "Preisaktionen",
        "Akcje listy: {name}": "Listenaktionen: {name}",
        "Akcje sekcji": "Abschnittsaktionen",
        "Akcje treści": "Inhaltsaktionen",
        "Akcje widżetu": "Widget-Aktionen",
        "Akcje widżetu {name}": "Aktionen für das Widget {name}",
        "Aktualna": "Aktuell",
        "Aktualności": "Aktuelles",
        "Aktualności ze strony": "Aktuelles von der Website",
        "Aktywacja kont po rejestracji": "Kontoaktivierung nach der Registrierung",
        "Aktywna": "Aktiv",
        "Aktywne": "Aktiv",
        "Aktywne do": "Aktiv bis",
        "Aktywne kanały:": "Aktive Kanäle:",
        "Aktywne od": "Aktiv ab",
        "Aktywne teraz": "Jetzt aktiv",
        "Aktywni użytkownicy": "Aktive Benutzer",
        "Aktywność użytkowników w ostatnich 30 minutach": "Benutzeraktivität in den letzten 30 Minuten",
        "Aktywny": "Aktiv",
        "Aktywuj": "Aktivieren",
        "Aktywuj przerwę techniczną w witrynie": "Wartungsmodus der Website aktivieren",
        "Alfabetycznie": "Alphabetisch",
        "Alternatywna": "Alternativ",
        "Angielski": "Englisch",
        "Ankieta": "Umfrage",
        "Ankieta dołączona do artykułu": "Umfrage im Artikel",
        "Ankieta nie ma jeszcze głosów": "Die Umfrage hat noch keine Stimmen",
        "Ankieta wyświetli się w miejscu wskazanym w treści artykułu. Aby je wskazać wybierz element \"Ankieta\" z narzędzi edytora": "Die Umfrage wird an der im Artikeltext angegebenen Stelle angezeigt. Um die Stelle festzulegen, wählen Sie im Editor das Element „Umfrage“ aus.",
        "Ankiety": "Umfragen",
        "Anulowane": "Abgebrochen",
        "Anuluj": "Abbrechen",
        "Anuluj edycję": "Bearbeitung abbrechen",
        "Aranżacja": "Layout",
        "Aranżacja alternatywna": "Alternatives Layout",
        "Aranżacja domyślna": "Standardlayout",
        "Aranżacja główna": "Hauptlayout",
        "Aranżacja i moduł": "Layout und Modul",
        "Aranżacja nie jest przypisana do żadnej strony": "Das Layout ist keiner Seite zugewiesen",
        "Aranżacja została dodana.": "Das Layout wurde hinzugefügt.",
        "Aranżacja została skopiowana.": "Das Layout wurde kopiert.",
        "Aranżacja została usunięta.": "Das Layout wurde gelöscht.",
        "Aranżacja została zaktualizowana.": "Das Layout wurde aktualisiert.",
        "Aranżacje": "Layouts",
        "Aranżacje docelowe": "Ziellayouts",
        "Archiwum": "Archiv",
        "artykuł": "Artikel",
        "Artykuł": "Artikel",
        "Artykuł na całą szerokość": "Artikel in voller Breite",
        "Artykuł otwarty": "Geöffneter Artikel",
        "Artykuł premium": "Premium-Artikel",
        "Artykuł sponsorowany": "Gesponserter Artikel",
        "artykułów": "Artikel",
        "artykuły": "Artikel",
        "Artykuły": "Artikel",
        "Artykuły oznaczone jako \"Śródtekstowe\" wyświetlą się w miejscu wskazanym w treści artykułu. Aby je wskazać wybierz element \"Powiązane artykuły\" z narzędzi edytora": "Artikel mit der Kennzeichnung „Im Text“ werden an der im Artikeltext angegebenen Stelle angezeigt. Um sie anzugeben, wählen Sie in den Editorwerkzeugen das Element „Verwandte Artikel“ aus",
        "Artykuły ze statusem PRIORYTET": "Artikel mit dem Status PRIORITÄT",
        "Asystent AI": "KI-Assistent",
        "Asystent nie zwrócił treści. Spróbuj ponownie.": "Der Assistent hat keinen Inhalt zurückgegeben. Bitte versuchen Sie es erneut.",
        "Asystent odpowie na podstawie treści artykułu – możesz też poprosić o przeredagowanie zaznaczonego fragmentu.": "Der Assistent antwortet auf Grundlage des Artikelinhalts – Sie können ihn auch bitten, den markierten Abschnitt umzuformulieren.",
        "Automat paczkowy": "Paketautomat",
        "Automatyczna akceptacja": "Automatische Freigabe",
        "Automatyczna akceptacja komentarzy zalogowanych": "Automatische Freigabe von Kommentaren angemeldeter Benutzer",
        "Automatyczna akceptacja wszystkich komentarzy": "Automatische Freigabe aller Kommentare",
        "Automatyczna publikacja galerii": "Automatische Veröffentlichung der Galerie",
        "Automatyczna publikacja wideo": "Automatische Veröffentlichung des Videos",
        "Automatyczne anulowanie zamówienia.": "Automatische Stornierung der Bestellung.",
        "Automatyczny": "Automatisch",
        "Automatyczny przewodnik po treściach witryny dla narzędzi AI.": "Automatischer Leitfaden zu den Inhalten der Website für KI-Tools.",
        "Autor": "Autor",
        "Autor będzie powiązany z kontem w panelu.": "Der Autor wird mit einem Konto im Dashboard verknüpft.",
        "Autor komentarza": "Kommentarautor",
        "Autor nie może zostać usunięty, ponieważ jest przypisany do artykułów": "Der Autor kann nicht gelöscht werden, da er Artikeln zugeordnet ist",
        "Autor został dodany.": "Der Autor wurde hinzugefügt.",
        "Autor został usunięty.": "Der Autor wurde gelöscht.",
        "Autor został zaktualizowany.": "Der Autor wurde aktualisiert.",
        "Autorzy": "Autoren",
        "Autorzy spoza bazy użytkowników": "Autoren außerhalb der Benutzerdatenbank",
        "Baner został dodany.": "Das Banner wurde hinzugefügt.",
        "Baner został zaktualizowany.": "Das Banner wurde aktualisiert.",
        "Banery": "Banner",
        "Banner został usunięty.": "Das Banner wurde gelöscht.",
        "Barwa tekstu": "Textfarbe",
        "Barwa tła": "Hintergrundfarbe",
        "Baza dokumentów": "Dokumentenbasis",
        "Bez \"http(s)://\" i \"/\" na końcu.": "Ohne „http(s)://“ und „/“ am Ende.",
        "Bez autora": "Ohne Autor",
        "Bez modułu": "Ohne Modul",
        "Bez witryny": "Ohne Website",
        "Bezpieczeństwo": "Sicherheit",
        "Bezpieczny adres URL": "Sichere URL",
        "bieżąca": "aktuell",
        "Błąd 404": "Fehler 404",
        "Błąd płatności": "Zahlungsfehler",
        "Błąd renderowania bloku": "Fehler beim Rendern des Blocks",
        "Blik": "Blik",
        "blisko limitu": "nahe am Limit",
        "Blokada /api/*, reguły przełączników AI i adresy sitemapy są dodawane automatycznie. Własne wpisy są z nimi łączone; reguły Allow mogą zmienić zakres blokad.": "Die Sperrung von /api/*, die Regeln für KI-Schalter und die Sitemap-Adressen werden automatisch hinzugefügt. Eigene Einträge werden mit ihnen zusammengeführt; Allow-Regeln können den Umfang der Sperrungen ändern.",
        "Brak": "Keine",
        "Brak akcji w tej sesji.": "Keine Aktionen in dieser Sitzung.",
        "Brak artykułów w czołówce.": "Keine Artikel im Aufmacher.",
        "Brak czołówki": "Kein Aufmacher",
        "Brak danych": "Keine Daten",
        "Brak danych do faktury.": "Keine Rechnungsdaten.",
        "Brak dodanych plików": "Keine Dateien hinzugefügt",
        "Brak dostępnej opublikowanej wersji tej aranżacji.": "Keine veröffentlichte Version dieses Layouts verfügbar.",
        "Brak dostępnych typów aranżacji": "Keine Layouttypen verfügbar",
        "Brak dostępnych typów widgetów.": "Keine Widgettypen verfügbar.",
        "Brak etykiety": "Keine Bezeichnung",
        "Brak historii cen.": "Keine Preisentwicklung.",
        "Brak innych aranżacji zawierających tę sekcję.": "Keine weiteren Layouts mit diesem Abschnitt.",
        "Brak kategorii": "Keine Kategorie",
        "Brak kategorii nadrzędnej": "Keine übergeordnete Kategorie",
        "Brak kategorii.": "Keine Kategorie.",
        "Brak komentarzy w tej zakładce.": "Keine Kommentare in diesem Tab.",
        "Brak listy regulaminów": "Keine Liste der Allgemeinen Geschäftsbedingungen",
        "Brak modułu": "Kein Modul",
        "Brak odpowiedzi": "Keine Antwort",
        "Brak odrzuconych zgód": "Keine abgelehnten Einwilligungen",
        "Brak opinii": "Keine Bewertungen",
        "Brak parametrów konfiguracji": "Keine Konfigurationsparameter",
        "Brak pasujących aranżacji": "Keine passenden Layouts",
        "Brak pasujących sekcji": "Keine passenden Abschnitte",
        "Brak pasujących widżetów": "Keine passenden Widgets",
        "brak pól": "keine Felder",
        "Brak potwierdzenia": "Keine Bestätigung",
        "Brak powiązań": "Keine Verknüpfungen",
        "Brak powiązanych artykułów.": "Keine verwandten Artikel.",
        "Brak pozycji.": "Keine Einträge.",
        "Brak przypisanych regulaminów.": "Keine zugeordneten Allgemeinen Geschäftsbedingungen.",
        "Brak regulaminów do zaakceptowania.": "Keine Allgemeinen Geschäftsbedingungen zu akzeptieren.",
        "Brak sekcji": "Keine Abschnitte",
        "Brak sekcji szablonu": "Keine Vorlagenabschnitte",
        "Brak sitemap.": "Keine Sitemap.",
        "Brak slajdów": "Keine Folien",
        "Brak stron": "Keine Seiten",
        "Brak stron dostępnych dla wybranej witryny i języka.": "Keine Seiten für die ausgewählte Website und Sprache verfügbar.",
        "Brak stron w katalogu": "Keine Seiten im Verzeichnis",
        "Brak strony nadrzędnej": "Keine übergeordnete Seite",
        "Brak uprawnień": "Keine Berechtigungen",
        "Brak uprawnień do edycji grupy banerów.": "Keine Berechtigung zum Bearbeiten der Bannergruppe.",
        "Brak uprawnień do usuwania linków wewnętrznych.": "Keine Berechtigung zum Löschen interner Links.",
        "Brak uprawnień do usuwania subskrypcji.": "Keine Berechtigung zum Löschen von Abonnements.",
        "Brak uprawnień do usuwania top tematów.": "Keine Berechtigung zum Löschen von Top-Themen.",
        "Brak użytkownika na liście oznacza, że jego imię lub nazwisko należy uzupełnić w dziale Użytkownicy.": "Fehlt ein Benutzer in der Liste, müssen sein Vor- oder Nachname im Bereich „Benutzer“ ergänzt werden.",
        "Brak widgetów w tym regionie.": "Keine Widgets in dieser Region.",
        "Brak widżetów pasujących do wyszukiwania.": "Keine Widgets passend zur Suche.",
        "Brak widżetów tego typu": "Keine Widgets dieses Typs",
        "Brak wpisów do edycji": "Keine Einträge zum Bearbeiten",
        "Brak wybranych autorów": "Keine Autoren ausgewählt",
        "Brak wyrażonych zgód": "Keine erteilten Einwilligungen",
        "Brak zamówień.": "Keine Bestellungen.",
        "Brak zestawów spełniających kryteria.": "Keine Sets erfüllen die Kriterien.",
        "Brak zgłoszeń": "Keine Meldungen",
        "brak zmian w polach": "keine Änderungen an den Feldern",
        "Brakuje obszaru na główną treść strony, np. artykuł. Wybierz szablon z obszarem „Treść modułu” lub dodaj go w konfiguracji szablonu.": "Der Bereich für den Hauptinhalt der Seite, z. B. einen Artikel, fehlt. Wählen Sie eine Vorlage mit dem Bereich „Modulinhalt“ aus oder fügen Sie ihn in der Vorlagenkonfiguration hinzu.",
        "Browse files": "Dateien durchsuchen",
        "Browse links": "Links durchsuchen",
        "Cache": "Cache",
        "Cała zawartość jest projektowana w PageBuilderze. Strona nie korzysta z modułu ani aranżacji CMS.": "Der gesamte Inhalt wird im PageBuilder gestaltet. Die Seite verwendet weder ein CMS-Modul noch ein CMS-Layout.",
        "Cel i zasięg": "Ziel und Umfang",
        "Cena": "Preis",
        "Cena brutto": "Bruttopreis",
        "Cena została wyłączona z historii.": "Der Preis wurde aus dem Verlauf ausgeschlossen.",
        "Cennik": "Preisliste",
        "CLS": "CLS",
        "CMS": "CMS",
        "Co godzinę": "Stündlich",
        "Co miesiąc": "Monatlich",
        "Co rok": "Jährlich",
        "Co tydzień": "Wöchentlich",
        "Codziennie": "Täglich",
        "Cofanie...": "Wird rückgängig gemacht …",
        "Cofnięto operację na widgetu": "Aktion am Widget rückgängig gemacht",
        "Cofnięto zmianę": "Änderung rückgängig gemacht",
        "Cofnij": "Rückgängig machen",
        "Cofnij ostatnią zmianę inline": "Letzte Inline-Änderung rückgängig machen",
        "Cykl życia zamówienia": "Bestelllebenszyklus",
        "Czas na slajd": "Anzeigedauer pro Folie",
        "Czas na stronie": "Verweildauer auf der Seite",
        "Czas po jakim zamówienie wygaśnie": "Zeit bis zum Ablauf der Bestellung",
        "Czas po jakim zamówienie zostanie anulowane": "Zeit bis zur Stornierung der Bestellung",
        "Czas UTC": "UTC-Zeit",
        "Czas życia": "Lebensdauer",
        "Czekam na metryki wydajności z podglądu.": "Warte auf Leistungsmetriken aus der Vorschau.",
        "Część zmiennych zostanie podstawiona dopiero przy renderowaniu.": "Einige Variablen werden erst beim Rendern ersetzt.",
        "Częstotliwość odświeżania": "Aktualisierungsintervall",
        "Częstotliwość zmian (changefreq)": "Änderungshäufigkeit (changefreq)",
        "Czołówka": "Vorspann",
        "Czołówka została dodana.": "Der Vorspann wurde hinzugefügt.",
        "Czołówka została usunięta.": "Der Vorspann wurde gelöscht.",
        "Czołówka została zaktualizowana.": "Der Vorspann wurde aktualisiert.",
        "Czwartek": "Donnerstag",
        "Czy chcesz ją przywrócić?": "Möchten Sie sie wiederherstellen?",
        "Czy na pewno chcesz usunąć tę stronę?": "Möchten Sie diese Seite wirklich löschen?",
        "Czytać mogą tylko zalogowani użytkownicy": "Nur angemeldete Benutzer können lesen",
        "Dalsza część artykułu przeznaczona jest dla osób z subskrypcją premium": "Der weitere Artikelinhalt ist Abonnenten mit Premium-Abo vorbehalten",
        "Dalsze polecenie": "Nächste Anweisung",
        "Dane autoryzacyjne Google Analytics": "Google-Analytics-Authentifizierungsdaten",
        "Dane developerskie skopiowane do schowka.": "Entwicklerdaten wurden in die Zwischenablage kopiert.",
        "Dane do faktury": "Rechnungsdaten",
        "Dane klienta": "Kundendaten",
        "Dane wpisu": "Eintragsdaten",
        "Dane wzoru": "Musterdaten",
        "Data": "Datum",
        "Data akceptacji": "Freigabedatum",
        "Data automatycznej akceptacji": "Datum der automatischen Freigabe",
        "Data dezaktywacji": "Deaktivierungsdatum",
        "Data do": "Datum bis",
        "Data dodania": "Hinzugefügt am",
        "Data i czas – 2026-09-04T14:30:00Z": "Datum und Uhrzeit – 2026-09-04T14:30:00Z",
        "Data i godzina": "Datum und Uhrzeit",
        "Data informująca o terminie wejścia w życie tego regulaminu.": "Datum des Inkrafttretens dieser Geschäftsordnung.",
        "Data modyfikacji": "Änderungsdatum",
        "Data od": "Datum ab",
        "Data odrzucenia": "Ablehnungsdatum",
        "Data opłacenia": "Zahlungsdatum",
        "Data publikacji": "Veröffentlichungsdatum",
        "Data publikacji regulaminu": "Veröffentlichungsdatum der Geschäftsordnung",
        "Data publikacji slajdera": "Veröffentlichungsdatum des Sliders",
        "Data rezygnacji": "Kündigungsdatum",
        "Data rozpoczęcia": "Startdatum",
        "Data wydania": "Ausgabedatum",
        "Data wygaśnięcia": "Ablaufdatum",
        "Data zakończenia": "Enddatum",
        "Data zakończenia publikacji nie może być wcześniejsza, niż jej rozpoczęcie": "Das Ende der Veröffentlichung darf nicht vor ihrem Beginn liegen",
        "Data zapisania się": "Anmeldedatum",
        "Data zgłoszenia": "Meldedatum",
        "Daty": "Daten",
        "Daty publikacji": "Veröffentlichungsdaten",
        "Daty publikacji zostały zaktualizowane.": "Die Veröffentlichungsdaten wurden aktualisiert.",
        "Definicja szablonu": "Vorlagendefinition",
        "Desktop": "Desktop",
        "Dev": "Dev",
        "Dezaktywuj": "Deaktivieren",
        "Diagnostyka": "Diagnose",
        "Dla procesu zakupowego": "Für den Kaufprozess",
        "Długość": "Länge",
        "Długość mieści się w zalecanym limicie.": "Die Länge liegt innerhalb des empfohlenen Grenzwerts.",
        "Długość zależy od podstawionej wartości.": "Die Länge hängt vom eingesetzten Wert ab.",
        "dni": "Tage",
        "Dni": "Tage",
        "Do odebrania w punkcie": "Zur Abholung in der Filiale",
        "Do poziomu": "Bis zur Ebene",
        "Docelowa strona": "Zielseite",
        "Dodaj": "Hinzufügen",
        "Dodaj aranżację": "Layout hinzufügen",
        "Dodaj artykuł": "Artikel hinzufügen",
        "Dodaj autora": "Autor hinzufügen",
        "Dodaj baner": "Banner hinzufügen",
        "Dodaj czołówkę": "Vorspann hinzufügen",
        "Dodaj definicję szablonu, aby skonfigurować jego sekcje.": "Fügen Sie eine Vorlagendefinition hinzu, um die Abschnitte der Vorlage zu konfigurieren.",
        "Dodaj dokument": "Dokument hinzufügen",
        "Dodaj element": "Element hinzufügen",
        "Dodaj etykietę": "Label hinzufügen",
        "Dodaj galerię": "Galerie hinzufügen",
        "Dodaj gazetkę": "Broschüre hinzufügen",
        "Dodaj grupę": "Gruppe hinzufügen",
        "Dodaj katalog": "Katalog hinzufügen",
        "Dodaj kategorie": "Kategorien hinzufügen",
        "Dodaj kategorię": "Kategorie hinzufügen",
        "Dodaj konkretny przykład zastosowania": "Konkretes Anwendungsbeispiel hinzufügen",
        "Dodaj link": "Link hinzufügen",
        "Dodaj nofollow": "Nofollow hinzufügen",
        "Dodaj nowa kategorię": "Neue Kategorie hinzufügen",
        "Dodaj nową witrynę aby rozpocząć zarządzanie stronami.": "Fügen Sie eine neue Website hinzu, um mit der Seitenverwaltung zu beginnen.",
        "Dodaj nowy katalog aby rozpocząć zarządzanie stronami.": "Fügen Sie einen neuen Katalog hinzu, um mit der Seitenverwaltung zu beginnen.",
        "Dodaj nowy tag": "Neues Tag hinzufügen",
        "Dodaj nowy widżet, podając jego nazwę poniżej.": "Fügen Sie ein neues Widget hinzu, indem Sie unten seinen Namen eingeben.",
        "Dodaj odpowiedź": "Antwort hinzufügen",
        "Dodaj opinię": "Bewertung hinzufügen",
        "Dodaj pierwszy slajd, aby uzupełnić obrazy i treść.": "Fügen Sie die erste Folie hinzu, um Bilder und Inhalte zu ergänzen.",
        "Dodaj plik": "Datei hinzufügen",
        "Dodaj powiązany artykuł": "Verwandten Artikel hinzufügen",
        "Dodaj powiązany rekord": "Verwandten Datensatz hinzufügen",
        "Dodaj powód": "Grund hinzufügen",
        "Dodaj przekierowanie": "Weiterleitung hinzufügen",
        "Dodaj publikację": "Publikation hinzufügen",
        "Dodaj pytanie": "Frage hinzufügen",
        "Dodaj rotator": "Rotator hinzufügen",
        "Dodaj sekcję": "Abschnitt hinzufügen",
        "Dodaj sekcję z kolumnami – w aranżacjach redaktorzy umieszczą w nich widgety.": "Abschnitt mit Spalten hinzufügen – in den Layouts platzieren Redakteure Widgets in diesen Spalten.",
        "Dodaj sekcję z kolumnami – w tych slotach redaktorzy będą umieszczać widgety w aranżacjach.": "Abschnitt mit Spalten hinzufügen – in den Layouts platzieren Redakteure Widgets in diesen Slots.",
        "Dodaj shortcode": "Shortcode hinzufügen",
        "Dodaj ShortCode": "ShortCode hinzufügen",
        "Dodaj slajd": "Folie hinzufügen",
        "Dodaj slajder": "Slider hinzufügen",
        "Dodaj słowo": "Wort hinzufügen",
        "Dodaj stronę": "Seite hinzufügen",
        "Dodaj szablon": "Vorlage hinzufügen",
        "Dodaj treść": "Inhalt hinzufügen",
        "Dodaj tutaj": "Hier hinzufügen",
        "Dodaj typ": "Typ hinzufügen",
        "Dodaj typ aranżacji": "Layouttyp hinzufügen",
        "Dodaj wideo": "Video hinzufügen",
        "Dodaj widget do sekcji": "Widget zum Abschnitt hinzufügen",
        "Dodaj widget tutaj": "Widget hier hinzufügen",
        "Dodaj widżet": "Widget hinzufügen",
        "Dodaj witrynę": "Website hinzufügen",
        "Dodaj wpis": "Beitrag hinzufügen",
        "Dodaj wybrane": "Ausgewählte hinzufügen",
        "Dodaj wzór": "Muster hinzufügen",
        "Dodaj zestaw": "Set hinzufügen",
        "Dodane przez": "Hinzugefügt von",
        "Dodane przez moje zespoły": "Von meinen Teams hinzugefügt",
        "Dodane przeze mnie": "Von mir hinzugefügt",
        "Dodanie aktualności": "Aktuelles hinzufügen",
        "Dodanie ankiety": "Umfrage hinzufügen",
        "Dodanie aranżacji": "Layout hinzufügen",
        "Dodanie artykułu": "Artikel hinzufügen",
        "Dodanie autora": "Autor hinzufügen",
        "Dodanie baneru": "Banner hinzufügen",
        "Dodanie czołówki": "Titelbild hinzufügen",
        "Dodanie dokumentu": "Dokument hinzufügen",
        "Dodanie etykiety": "Etikett hinzufügen",
        "Dodanie galerii": "Galerie hinzufügen",
        "Dodanie gazetki": "Broschüre hinzufügen",
        "Dodanie grupy": "Gruppe hinzufügen",
        "Dodanie kategorii": "Kategorie hinzufügen",
        "Dodanie linku": "Link hinzufügen",
        "Dodanie linku wewnętrznego": "Internen Link hinzufügen",
        "Dodanie pakietu": "Paket hinzufügen",
        "Dodanie poradnika": "Ratgeber hinzufügen",
        "Dodanie regulaminu": "Nutzungsbedingungen hinzufügen",
        "Dodanie rotatora": "Rotator hinzufügen",
        "Dodanie slajdera": "Slider hinzufügen",
        "Dodanie strony": "Seite hinzufügen",
        "Dodanie szablonu": "Vorlage hinzufügen",
        "Dodanie top tematu": "Top-Thema hinzufügen",
        "Dodanie wideo": "Video hinzufügen",
        "Dodanie witryny": "Website hinzufügen",
        "Dodanie wzoru": "Muster hinzufügen",
        "Dodanie zestawu regulaminów": "Nutzungsbedingungen-Satz hinzufügen",
        "dodano": "hinzugefügt",
        "Dodano widget": "Widget hinzugefügt",
        "Dodano za dużo stron (maksymalnie %0).": "Zu viele Seiten hinzugefügt (maximal %0).",
        "Dodatkowe parametry w adresie URL": "Zusätzliche Parameter in der URL",
        "Dodatkowe reguły robots.txt": "Zusätzliche robots.txt-Regeln",
        "Dodawanie ankiety": "Umfrage hinzufügen",
        "Dodawanie dokumentu": "Dokument hinzufügen",
        "Dodawanie galerii": "Galerie hinzufügen",
        "Dodawanie gazetki": "Broschüre hinzufügen",
        "Dodawanie linku": "Link hinzufügen",
        "Dodawanie pytań i odpowiedzi": "Fragen und Antworten hinzufügen",
        "Dodawanie rotatora": "Rotator hinzufügen",
        "Dodawanie tylko po zalogowaniu": "Nur nach der Anmeldung hinzufügen",
        "Dodawanie wideo": "Video hinzufügen",
        "Dokąd prowadzi odnośnik i gdzie obowiązuje.": "Wohin der Link führt und wo er gilt.",
        "Dokument": "Dokument",
        "Dokument nie jest jeszcze nigdzie opublikowany.": "Das Dokument ist noch nirgends veröffentlicht.",
        "Dokument nie ma ustawionej daty publikacji.": "Für das Dokument ist kein Veröffentlichungsdatum festgelegt.",
        "Dokument został dodany.": "Das Dokument wurde hinzugefügt.",
        "Dokument został usunięty.": "Das Dokument wurde gelöscht.",
        "Dokument został w międzyczasie zmieniony przez kogoś innego.": "Das Dokument wurde inzwischen von jemand anderem geändert.",
        "Dokument został w międzyczasie zmieniony przez kogoś innego. Nadpisanie zastąpi cudzą zmianę, a odświeżenie porzuci Twoją edycję i pokaże aktualne dane.": "Das Dokument wurde inzwischen von jemand anderem geändert. Durch das Überschreiben wird die Änderung der anderen Person ersetzt. Durch das Aktualisieren werden Ihre Änderungen verworfen und die aktuellen Daten angezeigt.",
        "Dokument został zaktualizowany.": "Das Dokument wurde aktualisiert.",
        "Dokumenty": "Dokumente",
        "Dołącz stronę do pliku sitemap.xml": "Seite zur Datei sitemap.xml hinzufügen",
        "domena witryny": "Website-Domain",
        "Domyślna": "Standard",
        "Domyślna stopka": "Standardfußzeile",
        "Domyślna strona dla wybranego modułu": "Standardseite für das ausgewählte Modul",
        "Domyślna witryna": "Standardwebsite",
        "Domyślne": "Standardeinstellungen",
        "Domyślne logo": "Standardlogo",
        "Domyślne ustawienie dla witryny": "Standardeinstellung für die Website",
        "Domyślny": "Standard",
        "Domyślny tytuł aktywnej strony": "Standardtitel der aktiven Seite",
        "Dopasowanie": "Anpassung",
        "Dostarczone": "Geliefert",
        "Dostawa": "Lieferung",
        "Dostęp robotów AI": "Zugriff für KI-Roboter",
        "Dostępna wersja robocza": "Verfügbare Entwurfsversion",
        "Dostępne dla": "Verfügbar für",
        "Dostępne i opublikowane wersje językowe witryny.": "Verfügbare und veröffentlichte Sprachversionen der Website.",
        "Dostępne języki": "Verfügbare Sprachen",
        "Dostępne moduły": "Verfügbare Module",
        "Dostępne sekcje": "Verfügbare Abschnitte",
        "Dostępne wersje językowe.": "Verfügbare Sprachversionen.",
        "Dostępne widgety zależą od witryny, języka i szablonu.": "Verfügbare Widgets hängen von der Website, der Sprache und der Vorlage ab.",
        "Dostępne widgety: {count}": "Verfügbare Widgets: {count}",
        "Dostępne widżety": "Verfügbare Widgets",
        "Dostępne wpisy: {count}": "Verfügbare Beiträge: {count}",
        "Dostępne zmienne": "Verfügbare Variablen",
        "Dostępność": "Verfügbarkeit",
        "Dostosuj kolumny dla tego urządzenia": "Spalten für dieses Gerät anpassen",
        "Dotyczy": "Betrifft",
        "Drugi klucz - md5": "Zweiter Schlüssel – MD5",
        "Drugie powiadomienie": "Zweite Benachrichtigung",
        "Duplikuj": "Duplizieren",
        "Duplikuj aranżację": "Layout duplizieren",
        "Duplikuj blok": "Block duplizieren",
        "Dynamiczny": "Dynamisch",
        "Dzień tygodnia": "Wochentag",
        "e-commerce": "E-Commerce",
        "E-mail": "E-Mail",
        "Edito tworzy plik automatycznie na podstawie publicznych treści uwzględnionych w mapie witryny. Nie musisz przygotowywać ani wgrywać pliku.": "Edito erstellt automatisch eine Datei auf Grundlage der öffentlichen Inhalte, die in der Sitemap enthalten sind. Sie müssen keine Datei erstellen oder hochladen.",
        "Edycja": "Bearbeiten",
        "Edycja aktualności": "Aktuelles bearbeiten",
        "Edycja ankiety": "Umfrage bearbeiten",
        "Edycja aranżacji": "Layout bearbeiten",
        "Edycja artykułu": "Artikel bearbeiten",
        "Edycja autora": "Autor bearbeiten",
        "Edycja baneru": "Banner bearbeiten",
        "Edycja czołówki": "Kopfbereich bearbeiten",
        "Edycja dokumentu": "Dokument bearbeiten",
        "Edycja etykiety": "Beschriftung bearbeiten",
        "Edycja galerii": "Galerie bearbeiten",
        "Edycja gazetki": "Broschüre bearbeiten",
        "Edycja grupy": "Gruppe bearbeiten",
        "Edycja kategorii": "Kategorie bearbeiten",
        "Edycja kategorii dokumentów": "Dokumentenkategorie bearbeiten",
        "Edycja komentarza": "Kommentar bearbeiten",
        "Edycja linku": "Link bearbeiten",
        "Edycja linku wewnętrznego": "Internen Link bearbeiten",
        "Edycja pakietu": "Paket bearbeiten",
        "Edycja poradnika": "Ratgeber bearbeiten",
        "Edycja pytań i odpowiedzi": "Fragen und Antworten bearbeiten",
        "Edycja pytania i odpowiedzi": "Frage und Antwort bearbeiten",
        "Edycja regulaminu": "Nutzungsbedingungen bearbeiten",
        "Edycja rotatora": "Rotator bearbeiten",
        "Edycja slajdera": "Slider bearbeiten",
        "Edycja strony": "Seite bearbeiten",
        "Edycja szablonu": "Vorlage bearbeiten",
        "Edycja top tematu": "Top-Thema bearbeiten",
        "Edycja ustawień": "Einstellungen bearbeiten",
        "Edycja wideo": "Video bearbeiten",
        "Edycja witryny": "Website bearbeiten",
        "Edycja wzoru": "Muster bearbeiten",
        "Edycja zestawu regulaminów": "Nutzungsbedingungen-Sammlung bearbeiten",
        "Edytowano pole": "Feld bearbeitet",
        "Edytuj": "Bearbeiten",
        "Edytuj adres e-mail": "E-Mail-Adresse bearbeiten",
        "Edytuj aranżację": "Layout bearbeiten",
        "Edytuj aranżację alternatywną": "Alternatives Layout bearbeiten",
        "Edytuj autora": "Autor bearbeiten",
        "Edytuj czołówkę": "Kopfbereich bearbeiten",
        "Edytuj datę": "Datum bearbeiten",
        "Edytuj etykietę": "Beschriftung bearbeiten",
        "Edytuj formularz": "Formular bearbeiten",
        "Edytuj kategorię": "Kategorie bearbeiten",
        "Edytuj kolor": "Farbe bearbeiten",
        "Edytuj kolumny sekcji": "Abschnittsspalten bearbeiten",
        "Edytuj komentarz": "Kommentar bearbeiten",
        "Edytuj liczbę": "Zahl bearbeiten",
        "Edytuj link": "Link bearbeiten",
        "Edytuj menu": "Menü bearbeiten",
        "Edytuj obszar": "Bereich bearbeiten",
        "Edytuj oś czasu": "Zeitleiste bearbeiten",
        "Edytuj plik": "Datei bearbeiten",
        "Edytuj powiązania": "Verknüpfungen bearbeiten",
        "Edytuj przekierowanie": "Weiterleitung bearbeiten",
        "Edytuj pytanie": "Frage bearbeiten",
        "Edytuj rotator": "Rotator bearbeiten",
        "Edytuj sekcję": "Abschnitt bearbeiten",
        "Edytuj shortcode": "Shortcode bearbeiten",
        "Edytuj slajder": "Slider bearbeiten",
        "Edytuj stronę": "Seite bearbeiten",
        "Edytuj tekst": "Text bearbeiten",
        "Edytuj treść": "Inhalt bearbeiten",
        "Edytuj widget": "Widget bearbeiten",
        "Edytuj wpis": "Beitrag bearbeiten",
        "Edytuj wstawkę": "Einfügung bearbeiten",
        "Edytuj wybór": "Auswahl bearbeiten",
        "Edytuj wybraną ankietę.": "Ausgewählte Umfrage bearbeiten.",
        "Edytuj zestaw": "Set bearbeiten",
        "Edytujesz sekcję {current} z {total}.": "Sie bearbeiten Abschnitt {current} von {total}.",
        "Eksport": "Export",
        "element": "Element",
        "elementów": "Elemente",
        "Elementy dostępne w aranżacjach tej witryny.": "Elemente, die in den Layouts dieser Website verfügbar sind.",
        "Elementy osi czasu": "Zeitleistenelemente",
        "Email": "E-Mail",
        "Email użytkownika": "E-Mail des Benutzers",
        "Entuzjastyczny": "Begeistert",
        "EQL": "EQL",
        "etykieta": "Etikett",
        "Etykieta": "Etikett",
        "Etykieta została dodana.": "Das Etikett wurde hinzugefügt.",
        "Etykieta została usunięta.": "Das Etikett wurde gelöscht.",
        "Etykieta została zaktualizowana.": "Das Etikett wurde aktualisiert.",
        "Etykiety": "Etiketten",
        "Etykiety pól na stronie": "Feldbeschriftungen auf der Seite",
        "Facebook Admins": "Facebook Admins",
        "Facebook Application ID": "Facebook Application ID",
        "Favicona": "Favicon",
        "Film": "Film",
        "Film z YouTube": "YouTube-Video",
        "Filtr audytu": "Auditfilter",
        "Filtry": "Filter",
        "Finalnie:": "Schließlich:",
        "Finalnie: pole będzie puste.": "Schließlich: Das Feld bleibt leer.",
        "Firma": "Unternehmen",
        "Folder został usunięty.": "Der Ordner wurde gelöscht.",
        "Forma płatności": "Zahlungsart",
        "Formalny": "Formell",
        "Format daty modyfikacji (lastmod)": "Format des Änderungsdatums (lastmod)",
        "Format pliku": "Dateiformat",
        "formularz": "Formular",
        "Formularz": "Formular",
        "Formularz kontaktowy": "Kontaktformular",
        "Formularz nie istnieje.": "Das Formular existiert nicht.",
        "Formularz określający pola wypełniane przy wstawianiu shortcode.": "Formular zur Festlegung der beim Einfügen des Shortcodes auszufüllenden Felder.",
        "Formularz wyświetlany pod artykułem": "Formular, das unter dem Artikel angezeigt wird",
        "Francuski": "Französisch",
        "Fraza": "Phrase",
        "Fraza podmieniana w treści na odnośnik.": "Phrase, die im Inhalt durch einen Link ersetzt wird.",
        "Front nie odpowiedział w wymaganym czasie.": "Das Frontend hat nicht innerhalb der erforderlichen Zeit geantwortet.",
        "Front zwrócił błąd:": "Das Frontend hat einen Fehler zurückgegeben:",
        "Funkcje dostępne podczas tworzenia stron witryny.": "Funktionen, die beim Erstellen von Website-Seiten verfügbar sind.",
        "Galeria": "Galerie",
        "Galeria nie jest jeszcze nigdzie opublikowana.": "Die Galerie wurde noch nirgendwo veröffentlicht.",
        "Galeria nie ma ustawionej daty publikacji.": "Für die Galerie ist kein Veröffentlichungsdatum festgelegt.",
        "Galeria zdjęć": "Fotogalerie",
        "Galeria zdjęć premium": "Premium-Fotogalerie",
        "Galeria została dodana.": "Die Galerie wurde hinzugefügt.",
        "Galeria została usunięta.": "Die Galerie wurde gelöscht.",
        "Galeria została zaktualizowana.": "Die Galerie wurde aktualisiert.",
        "Gazetka": "Prospekt",
        "Gazetka nie jest jeszcze nigdzie opublikowana.": "Der Prospekt wurde noch nirgendwo veröffentlicht.",
        "Gazetka nie ma ustawionej daty publikacji.": "Für den Prospekt ist kein Veröffentlichungsdatum festgelegt.",
        "Gazetka została dodana.": "Der Prospekt wurde hinzugefügt.",
        "Gazetka została usunięta.": "Der Prospekt wurde gelöscht.",
        "Gazetka została zaktualizowana.": "Der Prospekt wurde aktualisiert.",
        "Generowanie": "Generierung",
        "Generowanie sitemapów zostało zlecone. Może to potrwać kilka minut.": "Die Generierung der Sitemaps wurde in Auftrag gegeben. Dies kann einige Minuten dauern.",
        "Generowanie stron gazetek...": "Seiten der Prospekte werden generiert...",
        "Generowanie stron gazetki nie jest aktywne.": "Die Generierung von Prospektseiten ist nicht aktiv.",
        "Generowanie treści": "Inhalt generieren",
        "Generowanie trwa zbyt długo. Odśwież stronę, aby sprawdzić aktualny status.": "Die Generierung dauert zu lange. Aktualisieren Sie die Seite, um den aktuellen Status zu überprüfen.",
        "Generuj": "Generieren",
        "Generuj nowe sitemapy": "Neue Sitemaps generieren",
        "Generuj ponownie": "Erneut generieren",
        "Generuj strony gazetki": "Prospektseiten generieren",
        "Generuj treść": "Inhalt generieren",
        "Generuj wszystkie metadane": "Alle Metadaten generieren",
        "Generuję treść…": "Inhalt wird generiert…",
        "gł.": "Std.",
        "głos": "Stimme",
        "głosów": "Stimmen",
        "Główna": "Hauptseite",
        "Główny nagłówek widoczny na stronie artykułu.": "Die Hauptüberschrift, die auf der Artikelseite angezeigt wird.",
        "godz.": "Std.",
        "Godzina": "Uhrzeit",
        "Google Maps": "Google Maps",
        "Goście nie mogą dodawać komentarzy. Dostęp do czytania określa osobne ustawienie.": "Gäste können keine Kommentare hinzufügen. Der Lesezugriff wird durch eine separate Einstellung festgelegt.",
        "Goście nie mogą zgłaszać komentarzy do moderacji.": "Gäste können keine Kommentare zur Moderation melden.",
        "Gotowe": "Fertig",
        "Gotowe widgety: %0": "Fertige Widgets: %0",
        "Gotowe widżety": "Fertige Widgets",
        "Grafika wyświetlana jako okładka filmu.": "Grafik, die als Filmcover angezeigt wird.",
        "Grafiki": "Grafiken",
        "Granice widgetów na stronie": "Widget-Grenzen auf der Seite",
        "Grupa": "Gruppe",
        "Grupa banerów już nie istnieje.": "Die Bannergruppe existiert nicht mehr.",
        "Grupa banerów została dodana.": "Die Bannergruppe wurde hinzugefügt.",
        "Grupa banerów została usunięta.": "Die Bannergruppe wurde gelöscht.",
        "Grupa banerów została zaktualizowana.": "Die Bannergruppe wurde aktualisiert.",
        "Grupy": "Gruppen",
        "Historia": "Verlauf",
        "Historia wersji będzie dostępna po zapisaniu artykułu.": "Der Versionsverlauf ist verfügbar, nachdem der Artikel gespeichert wurde.",
        "Historia zmian ceny": "Verlauf der Preisänderungen",
        "Historia zmian inline": "Inline-Änderungsverlauf",
        "i posiadających wymagane uprawnienia": "und über die erforderlichen Berechtigungen verfügen",
        "Id": "ID",
        "ID": "ID",
        "id aktualnej rewizji": "ID der aktuellen Revision",
        "id pierwszej wersji": "ID der ersten Version",
        "Id punktu płatności - posId": "ID des Zahlungspunkts – posId",
        "Id wpisu": "Eintrags-ID",
        "Identyfikator aplikacji Meta powiązanej z witryną.": "ID der mit der Website verknüpften Meta-Anwendung.",
        "Identyfikator filmu z adresu YouTube, np. część po v=.": "ID des YouTube-Videos, z. B. der Teil nach v=.",
        "Identyfikator kontenera Google Tag Manager używanego w tej witrynie.": "ID des Google Tag Manager-Containers, der auf dieser Website verwendet wird.",
        "Identyfikator OAuth używany do połączenia z PayU. Skopiuj client_id z konfiguracji punktu POS.": "OAuth-ID für die Verbindung mit PayU. Kopieren Sie die client_id aus der POS-Punkt-Konfiguration.",
        "Identyfikator punktu płatności w PayU. Znajdziesz go w konfiguracji punktu POS w panelu PayU.": "ID des Zahlungspunkts bei PayU. Sie finden sie in der POS-Punkt-Konfiguration im PayU-Panel.",
        "Identyfikator sekcji": "Abschnitts-ID",
        "Identyfikator usługi Google Analytics": "Google-Analytics-Property-ID",
        "Identyfikator usługi Google Analytics, z której mają być pobierane statystyki.": "ID der Google-Analytics-Property, aus der Statistiken abgerufen werden sollen.",
        "Ikona": "Symbol",
        "Ikona pomagająca rozpoznać wzór podczas wyboru shortcode.": "Symbol, das dabei hilft, eine Vorlage bei der Auswahl eines Shortcodes zu erkennen.",
        "Ikona wyświetlana jest w postaci kwadratu.": "Das Symbol wird als Quadrat angezeigt.",
        "Ile dni przed zakończeniem subskrypcji autoodnawialnej rozpocznie się pobranie płatności.": "Wie viele Tage vor Ablauf des automatisch verlängerten Abonnements die Zahlung eingezogen wird.",
        "Ile razy system ponawia nieudaną płatność.": "Wie oft das System eine fehlgeschlagene Zahlung erneut versucht.",
        "Ilość dni przed": "Anzahl der Tage vorher",
        "Ilość kolumn podkategorii": "Anzahl der Unterkategoriespalten",
        "Ilość powtórzeń po wystąpieniu błędu": "Anzahl der Wiederholungen nach einem Fehler",
        "Ilość publikacji: %0": "Anzahl der Veröffentlichungen: %0",
        "Ilość wybranych stron: %0": "Anzahl der ausgewählten Seiten: %0",
        "Ilość wyświetlanych aktualności": "Anzahl der angezeigten Meldungen",
        "Ilość wyświetlanych artykułów": "Anzahl der angezeigten Artikel",
        "Ilość wyświetlanych tagów": "Anzahl der angezeigten Tags",
        "Ilość zaakceptowanych regulaminów: ": "Anzahl der akzeptierten Nutzungsbedingungen: ",
        "Im konkretniejsze polecenie, tym lepszy efekt – podaj temat, długość i ton wypowiedzi.": "Je konkreter die Anweisung, desto besser das Ergebnis – geben Sie Thema, Länge und Ton an.",
        "Imię": "Vorname",
        "Imię i nazwisko / nazwa autora": "Vor- und Nachname / Name des Autors",
        "Import": "Import",
        "Indeksowanie strony": "Seitenindexierung",
        "Informacja": "Information",
        "Informacja o ciasteczkach": "Cookie-Hinweis",
        "Informacje o komentarzu": "Kommentarinformationen",
        "Informacje o zamówieniu": "Bestellinformationen",
        "inline": "Inline",
        "INP": "INP",
        "Inspekcja": "Inspektion",
        "Integracje": "Integrationen",
        "Interakcja użytkownika (Komenatrze, Like)": "Benutzerinteraktionen (Kommentare, Likes)",
        "ISBN": "ISBN",
        "Jak przetworzyć zaznaczony fragment?": "Wie soll der markierte Text verarbeitet werden?",
        "jawne": "explizit",
        "Jedno zdanie widoczne przy artykułach": "Ein Satz, der bei Artikeln angezeigt wird",
        "Jeśli pole jest puste to wstawiana automatycznie.": "Wenn das Feld leer ist, wird der Wert automatisch eingefügt.",
        "Jest używana jako ekran logowania. Dla danego języka może istnieć tylko jedna.": "Wird als Anmeldebildschirm verwendet. Für jede Sprache kann es nur einen geben.",
        "Jesteś w drugim dialogu: dodawanie powiązanego rekordu.": "Sie befinden sich im zweiten Dialog: Verknüpften Datensatz hinzufügen.",
        "Jesteś w drugim dialogu: edycja formularza.": "Sie befinden sich im zweiten Dialog: Formular bearbeiten.",
        "Jesteś w drugim dialogu: edycja wpisu.": "Sie befinden sich im zweiten Dialog: Eintrag bearbeiten.",
        "Język": "Sprache",
        "Język domyślny": "Standardsprache",
        "Język i ton": "Sprache und Ton",
        "Język regulaminu": "Sprache der Nutzungsbedingungen",
        "Języki": "Sprachen",
        "JSON szablonu": "JSON-Vorlage",
        "Kanał RSS:": "RSS-Feed:",
        "Karta": "Karte",
        "Karta produktu": "Produktkarte",
        "Katalog": "Verzeichnis",
        "Katalog główny": "Stammverzeichnis",
        "Katalog i pozycja strony w strukturze witryny.": "Verzeichnis und Position der Seite in der Website-Struktur.",
        "Katalog linków": "Linkverzeichnis",
        "Katalog został utworzony.": "Das Verzeichnis wurde erstellt.",
        "Kategoria": "Kategorie",
        "Kategoria linku": "Linkkategorie",
        "Kategoria nadrzędna": "Übergeordnete Kategorie",
        "Kategoria subskrypcji": "Abonnementkategorie",
        "Kategoria subskrypcji została dodana.": "Die Abonnementkategorie wurde hinzugefügt.",
        "Kategoria subskrypcji została usunięta.": "Die Abonnementkategorie wurde gelöscht.",
        "Kategoria subskrypcji została zaktualizowana.": "Die Abonnementkategorie wurde aktualisiert.",
        "Kategoria urządzenia": "Gerätekategorie",
        "Kategoria zawierająca formularz dla tego wzoru.": "Kategorie mit dem Formular für diese Vorlage.",
        "Kategoria została dodana.": "Die Kategorie wurde hinzugefügt.",
        "Kategoria została usunięta.": "Die Kategorie wurde gelöscht.",
        "Kategoria została zaktualizowana.": "Die Kategorie wurde aktualisiert.",
        "Kategorie": "Kategorien",
        "Kategorię": "Kategorie",
        "Kategorie linków": "Linkkategorien",
        "Kategorię można opublikować tylko na jednej stronie.": "Eine Kategorie kann nur auf einer Seite veröffentlicht werden.",
        "Kategorie subskrypcji": "Abonnementkategorien",
        "Każdy komentarz pojawia się od razu.": "Jeder Kommentar wird sofort angezeigt.",
        "Kiedy": "Wann",
        "Klienci": "Kunden",
        "Klient": "Kunde",
        "Kliknij stronę w drzewie po lewej, aby edytować jej ustawienia i metadane.": "Klicken Sie im Baum links auf eine Seite, um ihre Einstellungen und Metadaten zu bearbeiten.",
        "Kliknij wybraną sekcję. Naciśnij Esc, aby anulować.": "Klicken Sie auf den gewünschten Abschnitt. Drücken Sie Esc, um abzubrechen.",
        "Kliknij Zapisz u góry strony, aby opublikować zmianę.": "Klicken Sie oben auf der Seite auf „Speichern“, um die Änderung zu veröffentlichen.",
        "Klucz API wykorzystywany przez mapy Google w witrynie.": "API-Schlüssel, der von Google Maps auf der Website verwendet wird.",
        "Klucz OAuth używany razem z clientId do autoryzacji połączenia z PayU. Skopiuj client_secret z tego samego punktu POS.": "OAuth-Schlüssel, der zusammen mit clientId zur Autorisierung der Verbindung mit PayU verwendet wird. Kopieren Sie client_secret aus demselben POS-Punkt.",
        "Klucz zgody Ipresso": "Ipresso-Einwilligungsschlüssel",
        "Kobieta": "Frau",
        "Kod / miasto": "Postleitzahl / Stadt",
        "Kod bannera (tutaj wklej kod HTML i JS)": "Banner-Code (HTML- und JS-Code hier einfügen)",
        "Kod Bing Webmaster": "Bing-Webmaster-Code",
        "Kod Google Webmaster": "Google-Webmaster-Code",
        "Kod GTM": "GTM-Code",
        "Kod HTML": "HTML-Code",
        "Kod weryfikacji witryny w Bing Webmaster Tools, bez całego znacznika HTML.": "Code zur Website-Verifizierung in Bing Webmaster Tools, ohne das vollständige HTML-Tag.",
        "Kod weryfikacji witryny w Google Search Console, bez całego znacznika HTML.": "Code zur Website-Verifizierung in der Google Search Console, ohne das vollständige HTML-Tag.",
        "kolejność": "Reihenfolge",
        "Kolejność odpowiedzi": "Reihenfolge der Antworten",
        "Kolejność opinii": "Reihenfolge der Bewertungen",
        "Kolejność pytań i odpowiedzi": "Reihenfolge der Fragen und Antworten",
        "Kolejność pytań zmienisz przeciąganiem lub strzałkami": "Die Reihenfolge der Fragen können Sie per Drag-and-drop oder mit den Pfeilen ändern",
        "Kolejność sekcji": "Reihenfolge der Abschnitte",
        "Kolejność zmienisz przeciąganiem": "Die Reihenfolge können Sie per Drag-and-drop ändern",
        "Kolejność zmienisz przeciąganiem lub strzałkami": "Die Reihenfolge können Sie per Drag-and-drop oder mit den Pfeilen ändern",
        "Kolor": "Farbe",
        "Kolor tekstu": "Textfarbe",
        "Kolor tekstu komunikatu.": "Textfarbe der Meldung.",
        "Kolor tła": "Hintergrundfarbe",
        "Kolor tła komunikatu.": "Hintergrundfarbe der Meldung.",
        "Kolumna {index}": "Spalte {index}",
        "Kolumna {index} (%)": "Spalte {index} (%)",
        "Kolumna {number}": "Spalte {number}",
        "Kolumny": "Spalten",
        "Komentarz": "Kommentar",
        "Komentarz do wyłączenia ceny": "Kommentar zur Deaktivierung des Preises",
        "Komentarze": "Kommentare",
        "Komentarze dłuższe nie zostaną zapisane.": "Längere Kommentare werden nicht gespeichert.",
        "Komentarze gości trafiają do moderacji.": "Kommentare von Gästen werden moderiert.",
        "Komentarze włączone": "Kommentare aktiviert",
        "Komentarze zawierające te słowa będą blokowane lub moderowane.": "Kommentare, die diese Wörter enthalten, werden blockiert oder moderiert.",
        "Komputer": "Computer",
        "Komunikat mailowy": "E-Mail-Nachricht",
        "Konfiguracja": "Konfiguration",
        "Konfiguracja aranżacji jest niedostępna ponieważ nie podano definicji szablonu.": "Die Konfiguration des Layouts ist nicht verfügbar, da keine Vorlagendefinition angegeben wurde.",
        "Konfiguracja shortcode": "Shortcode-Konfiguration",
        "Konfiguracja szablonu": "Vorlagenkonfiguration",
        "Konfiguracja widgetów jest niedostępna ponieważ nie podano definicji szablonu.": "Die Widget-Konfiguration ist nicht verfügbar, da keine Vorlagendefinition angegeben wurde.",
        "Konfiguracja widgetu została zapisana.": "Die Widget-Konfiguration wurde gespeichert.",
        "Konfiguruj stronę": "Seite konfigurieren",
        "Konflikt edycji": "Bearbeitungskonflikt",
        "Kontener": "Container",
        "Konto": "Konto",
        "Konto jest aktywne od razu po rejestracji.": "Das Konto ist direkt nach der Registrierung aktiv.",
        "Konto publiczne": "Öffentliches Konto",
        "Kontynent": "Kontinent",
        "kopia": "Kopie",
        "Kopiuj": "Kopieren",
        "Kopiuj adres": "Adresse kopieren",
        "Kopiuj do witryny": "In Website kopieren",
        "Kopiuj link": "Link kopieren",
        "Kopiuj path": "Pfad kopieren",
        "Kopiuj sekcję do aranżacji": "Abschnitt in Layout kopieren",
        "Kopiuj widget": "Widget kopieren",
        "Kopiuj widżet do witryny": "Widget in Website kopieren",
        "Kopiuj zmienną": "Variable kopieren",
        "Korzysta wyłącznie z ustawień z zakładki Podstawowe.": "Verwendet ausschließlich die Einstellungen aus dem Tab „Allgemein“.",
        "Koszyk": "Warenkorb",
        "Kraj": "Land",
        "Kreator stron": "Website-Baukasten",
        "Krótki identyfikator wzoru używany w systemie.": "Kurze Kennung des im System verwendeten Musters.",
        "Krótki opis": "Kurzbeschreibung",
        "Krótki opis widoczny na listingu linków": "Kurze Beschreibung, die in der Linkliste angezeigt wird",
        "Krótki tytuł": "Kurztitel",
        "Krótkie wprowadzenie przed główną treścią artykułu.": "Kurze Einleitung vor dem Hauptinhalt des Artikels.",
        "krytyczne": "kritisch",
        "Krytyczne": "Kritisch",
        "Książka": "Buch",
        "Kto może korzystać z systemu komentarzy.": "Wer das Kommentarsystem nutzen darf.",
        "Kurier": "Kurier",
        "Ładowanie edytora...": "Editor wird geladen...",
        "Ładowanie elementów...": "Elemente werden geladen...",
        "Ładowanie podglądu...": "Vorschau wird geladen...",
        "Ładowanie pól...": "Felder werden geladen...",
        "Ładowanie treści...": "Inhalte werden geladen...",
        "Ładowanie zgłoszeń…": "Meldungen werden geladen…",
        "Ładuję opublikowaną wersję...": "Veröffentlichte Version wird geladen...",
        "Ładuję wersję roboczą...": "Entwurf wird geladen...",
        "LCP": "LCP",
        "Liczba": "Anzahl",
        "Liczba ankiet": "Anzahl der Umfragen",
        "Liczba artykułów": "Anzahl der Artikel",
        "Liczba kolumn": "Anzahl der Spalten",
        "Liczba kolumn w wierszu": "Anzahl der Spalten pro Zeile",
        "Liczba opinii: {count}. Kolejność zmienisz przeciąganiem lub strzałkami.": "Anzahl der Bewertungen: {count}. Die Reihenfolge können Sie per Drag-and-drop oder mit den Pfeilen ändern.",
        "Liczba ponowień płatności": "Anzahl der Zahlungswiederholungen",
        "Liczba slajdów widoczna dla użytkownika nie może być większa od liczby slajdów dodanych w panelu.": "Die für den Benutzer sichtbare Anzahl der Folien darf nicht größer sein als die Anzahl der im Adminbereich hinzugefügten Folien.",
        "Liczba stron głównego poziomu: {count}": "Anzahl der Seiten der obersten Ebene: {count}",
        "Liczba widżetów: {count}": "Anzahl der Widgets: {count}",
        "Liczba wyników": "Anzahl der Ergebnisse",
        "Liczba wyświetlanych najnowszych elementów": "Anzahl der angezeigten neuesten Elemente",
        "Liczba wyświetlanych slajdów": "Anzahl der angezeigten Folien",
        "Liczba wyświetleń": "Anzahl der Aufrufe",
        "Liczba zamówień": "Anzahl der Bestellungen",
        "Liczba znaków:": "Zeichenanzahl:",
        "Like do komentarzy mogą dodawać tylko zalogowani użytkownicy": "Likes für Kommentare können nur angemeldete Benutzer vergeben",
        "Limit zgłoszeń": "Meldungslimit",
        "Limity": "Limits",
        "Limity treści": "Inhaltslimits",
        "Linia ciągła": "Durchgezogene Linie",
        "Linia falująca": "Wellenlinie",
        "Linia kreskowana": "Gestrichelte Linie",
        "Linia kropkowana": "Gepunktete Linie",
        "Link": "Link",
        "Link do strony": "Link zur Seite",
        "Link do widgetu skopiowany do schowka.": "Der Link zum Widget wurde in die Zwischenablage kopiert.",
        "Link do YouTube, Vimeo lub pliku mp4.": "Link zu YouTube, Vimeo oder einer MP4-Datei.",
        "Link może prowadzić do pliku z repozytorium albo do zewnętrznego serwisu": "Der Link kann zu einer Datei im Repository oder zu einem externen Dienst führen",
        "Link obszaru": "Bereichslink",
        "Link prowadzi do pliku z repozytorium.": "Der Link führt zu einer Datei im Repository.",
        "Link prowadzi do zewnętrznego adresu.": "Der Link führt zu einer externen Adresse.",
        "Link wewnętrzny": "Interner Link",
        "Link wewnętrzny został dodany.": "Der interne Link wurde hinzugefügt.",
        "Link wewnętrzny został usunięty.": "Der interne Link wurde gelöscht.",
        "Link wewnętrzny został zaktualizowany.": "Der interne Link wurde aktualisiert.",
        "Link wygasł": "Der Link ist abgelaufen",
        "Link z serwisu": "Link zum Dienst",
        "Link zewnętrzny": "Externer Link",
        "Link został dodany.": "Der Link wurde hinzugefügt.",
        "Link został usunięty.": "Der Link wurde gelöscht.",
        "Link został zaktualizowany.": "Der Link wurde aktualisiert.",
        "Linki wewnętrzne": "Interne Links",
        "Linki wewnętrzne zostały pomyślnie połączone.": "Die internen Links wurden erfolgreich zusammengeführt.",
        "Lista": "Liste",
        "Lista artykułów": "Artikelliste",
        "Lista banerów": "Bannerliste",
        "Lista komentarzy": "Kommentarliste",
        "Lista linków": "Linkliste",
        "Lista publikacji": "Publikationsliste",
        "Lista regulaminów": "Liste der Nutzungsbedingungen",
        "Lista wyświetlana użytkownikowi przy zgłaszaniu.": "Liste, die dem Benutzer beim Melden angezeigt wird.",
        "Live Design": "Live Design",
        "Live design (beta)": "Live-Design (Beta)",
        "llms.txt to rozwiązanie eksperymentalne": "llms.txt ist eine experimentelle Lösung",
        "Logo": "Logo",
        "Logo używane w wiadomościach tej witryny. Jeśli nie wybierzesz pliku, zostanie użyte domyślne logo systemu.": "Logo, das in den Nachrichten dieser Website verwendet wird. Wenn Sie keine Datei auswählen, wird das Standardlogo des Systems verwendet.",
        "Logowanie": "Anmeldung",
        "Lp.": "Nr.",
        "Maksymalna ilość stron": "Maximale Seitenanzahl",
        "Maksymalna liczba najnowszych elementów pokazywanych na liście.": "Maximale Anzahl der neuesten Elemente, die in der Liste angezeigt werden.",
        "Maksymalna liczba pozycji w kanale": "Maximale Anzahl der Einträge im Feed",
        "Maksymalna liczba znaków dla niezalogowanych": "Maximale Zeichenanzahl für nicht angemeldete Benutzer",
        "Maksymalna liczba znaków dla zalogowanych": "Maximale Zeichenanzahl für angemeldete Benutzer",
        "Maksymalna szerokość strony to 1410": "Die maximale Seitenbreite beträgt 1410",
        "Maksymalna wysokość strony to 1080": "Die maximale Seitenhöhe beträgt 1080",
        "Mapowanie pól modułów Studio (JSON)": "Zuordnung der Felder von Studio-Modulen (JSON)",
        "Marketing": "Marketing",
        "Masz niezapisane zmiany. Przejść bez zapisywania?": "Sie haben ungespeicherte Änderungen. Möchten Sie fortfahren, ohne zu speichern?",
        "Materiał wideo dołączony do wpisu": "Zum Beitrag hinzugefügtes Video",
        "Menu widgetu": "Widget-Menü",
        "Metadane": "Metadaten",
        "Metryka": "Metrik",
        "Mężczyzna": "Männlich",
        "Miasto": "Stadt",
        "Miejsce ankiety": "Umfrageort",
        "Miejsce artykułu w strukturze serwisu": "Position des Artikels in der Website-Struktur",
        "Miejsce otwarcia odnośnika (atrybut target), np. _blank dla nowej karty.": "Ziel des Links (target-Attribut), z. B. _blank für einen neuen Tab.",
        "Miejsce powiązanych artykułów": "Bereich für verwandte Artikel",
        "Miesiące": "Monate",
        "Miniatura wyświetlana przed odtworzeniem": "Vorschaubild, das vor der Wiedergabe angezeigt wird",
        "Minimalna szerokość strony to 370": "Die Mindestseitenbreite beträgt 370",
        "Minimalna wysokość strony to 500": "Die Mindestseitenhöhe beträgt 500",
        "Mobile": "Mobil",
        "Moduł": "Modul",
        "Moduł dynamiczny": "Dynamisches Modul",
        "Moduł konfigurowalny": "Konfigurierbares Modul",
        "Moduł nie wskazuje formularza dla sekcji tego widgetu.": "Das Modul verweist auf kein Formular für die Abschnitte dieses Widgets.",
        "Moduł Studio zawierający formularz do wyświetlenia.": "Studio-Modul mit dem anzuzeigenden Formular.",
        "Moduły": "Module",
        "Moduły wyszukiwarki": "Suchmodule",
        "Możesz zacząć od:": "Sie können beginnen mit:",
        "Można ich używać we wszystkich polach tekstowych.": "Sie können in allen Textfeldern verwendet werden.",
        "Multimedia": "Multimedia",
        "Multimedia premium": "Premium-Multimedia",
        "Multimedia przypisane do artykułu": "Dem Artikel zugeordnete Multimedia-Inhalte",
        "Na ile dni po zakończeniu subskrypcji wysłać powiadomienie.": "Wie viele Tage nach Ablauf des Abonnements soll eine Benachrichtigung gesendet werden.",
        "Na ile dni przed końcem subskrypcji wysłać przypomnienie.": "Wie viele Tage vor Ablauf des Abonnements soll eine Erinnerung gesendet werden.",
        "Nabywca": "Käufer",
        "Naciśnij enter aby usunąć": "Drücken Sie die Eingabetaste, um zu löschen",
        "Naciśnij enter aby wybrać": "Drücken Sie die Eingabetaste, um auszuwählen",
        "Nadaj banerowi nazwę, wybierz grupę i określ adres docelowy.": "Geben Sie dem Banner einen Namen, wählen Sie eine Gruppe aus und legen Sie die Zieladresse fest.",
        "Nadaj sekcji czytelną nazwę używaną podczas edycji aranżacji.": "Geben Sie dem Abschnitt einen aussagekräftigen Namen, der beim Bearbeiten des Layouts verwendet wird.",
        "Nadpisz": "Überschreiben",
        "Nagłówek widgetu widoczny dla odwiedzających stronę.": "Überschrift des Widgets, die für Besucher der Website sichtbar ist.",
        "Najczęstszy wybór. Wyświetla dane z wybranego modułu, np. Aktualności, Kontakt lub Reklamacje. Wymaga modułu i aranżacji.": "Die häufigste Auswahl. Zeigt Daten aus dem ausgewählten Modul an, z. B. Nachrichten, Kontakt oder Reklamationen. Erfordert ein Modul und ein Layout.",
        "Najedź na widget albo pole w podglądzie.": "Bewegen Sie den Mauszeiger im Vorschaubereich über das Widget oder Feld.",
        "Najlepiej wybrać logo w formacie SVG — pozostaje ostre w każdym rozmiarze i dobrze wygląda na ekranach o wysokiej rozdzielczości.": "Wählen Sie am besten ein Logo im SVG-Format – es bleibt bei jeder Größe scharf und sieht auch auf hochauflösenden Bildschirmen gut aus.",
        "Najniższa cena z 30 dni przed obniżką": "Niedrigster Preis der letzten 30 Tage vor der Preissenkung",
        "Najniższy": "Niedrigster",
        "Najnowsza wersja": "Neueste Version",
        "Najpierw dodaj stronę do gazetki.": "Fügen Sie zuerst eine Seite zum Prospekt hinzu.",
        "Najpierw wybierz typ aranżacji": "Wählen Sie zuerst den Layouttyp aus",
        "Najpierw zapisz aranżację.": "Speichern Sie zuerst das Layout.",
        "Najpopularniejsze strony": "Beliebteste Seiten",
        "Najwięcej czasu spędzone na stronach": "Am meisten Zeit auf den Seiten verbracht",
        "Najwyższy": "Höchster",
        "Napisz krótki lead na podstawie fragmentu": "Verfassen Sie anhand des Auszugs einen kurzen Lead",
        "Napisz wstęp do artykułu o wdrożeniu nowego portalu": "Schreiben Sie eine Einleitung für einen Artikel über die Einführung eines neuen Portals",
        "Narzędzia": "Werkzeuge",
        "Narzędzia podglądu": "Vorschauwerkzeuge",
        "Następne pole": "Nächstes Feld",
        "Nazwa": "Name",
        "Nazwa adresu": "Adressname",
        "Nazwa aktywnej strony": "Name der aktiven Seite",
        "Nazwa aranżacji": "Name des Layouts",
        "Nazwa autora": "Name des Autors",
        "Nazwa czołówki": "Name des Headers",
        "Nazwa etapu": "Name der Phase",
        "Nazwa etykiety": "Name des Labels",
        "Nazwa grupy": "Name der Gruppe",
        "Nazwa i adres strony w witrynie.": "Name und Adresse der Seite auf der Website.",
        "Nazwa katalogu": "Name des Katalogs",
        "Nazwa kategorii": "Name der Kategorie",
        "Nazwa Kategorii": "Name der Kategorie",
        "Nazwa linku": "Name des Links",
        "Nazwa nowej kategorii": "Name der neuen Kategorie",
        "Nazwa obiektu": "Name des Objekts",
        "Nazwa pakietu": "Name des Pakets",
        "Nazwa płyty": "Name der Platte",
        "Nazwa rotatora": "Name des Rotators",
        "Nazwa sekcji": "Name des Abschnitts",
        "Nazwa shortcode": "Name des Shortcodes",
        "Nazwa slajdera": "Name des Sliders",
        "Nazwa slajdu": "Name des Slides",
        "Nazwa strony": "Name der Seite",
        "Nazwa szablonu": "Name der Vorlage",
        "Nazwa typu aranżacji": "Name des Layouttyps",
        "Nazwa ułatwia rozpoznanie aranżacji przy przypisywaniu jej do strony.": "Der Name erleichtert die Zuordnung des Layouts zu einer Seite.",
        "Nazwa w panelu": "Name im Panel",
        "Nazwa wewnętrzna": "Interner Name",
        "Nazwa widoczna na liście wzorów. Powinna jasno wskazywać przeznaczenie shortcode.": "Name, der in der Vorlagenliste angezeigt wird. Er sollte den Zweck des Shortcodes eindeutig angeben.",
        "Nazwa widoczna na stronie i w panelu oraz miejsce w drzewie": "Name, der auf der Seite und im Panel angezeigt wird, sowie Position im Baum",
        "Nazwa widoczna wyłącznie w panelu administracyjnym.": "Name, der ausschließlich im Administrationsbereich angezeigt wird.",
        "Nazwa widżetu": "Name des Widgets",
        "Nazwa witryny": "Name der Website",
        "Nazwa wyświetlana": "Anzeigename",
        "Nazwa zduplikowanej aranżacji": "Name des duplizierten Layouts",
        "Nazwa, domena i szablon graficzny witryny.": "Name, Domain und grafische Vorlage der Website.",
        "Nazwa, opis i przypisanie linku": "Name, Beschreibung und Linkzuordnung",
        "Nazwa, oznaczenie i ikona shortcode.": "Name, Bezeichnung und Symbol des Shortcodes.",
        "Nazwisko": "Nachname",
        "Neutralny": "Neutral",
        "Nic nie publikuje się bez zatwierdzenia.": "Nichts wird ohne Freigabe veröffentlicht.",
        "Nie": "Nein",
        "Nie dodano żadnego autora.": "Es wurde kein Autor hinzugefügt.",
        "Nie ma jeszcze żadnych rekordów": "Es sind noch keine Datensätze vorhanden",
        "Nie ma własnej treści. Kieruje do wybranej strony tej samej witryny; można dodać parametry URL.": "Enthält keine eigenen Inhalte. Führt zu einer ausgewählten Seite derselben Website; URL-Parameter können hinzugefügt werden.",
        "Nie ma własnej treści. Kieruje pod podany pełny adres URL i może otworzyć go w nowym oknie.": "Enthält keine eigenen Inhalte. Führt zur angegebenen vollständigen URL und kann diese in einem neuen Fenster öffnen.",
        "Nie można już edytować tego linku wewnętrznego, ponieważ jest on aktualnie używany.": "Dieser interne Link kann nicht mehr bearbeitet werden, da er derzeit verwendet wird.",
        "Nie można usunąć zaznaczonych autorów, ponieważ co najmniej jeden z nich jest przypisany do artykułów.": "Die ausgewählten Autoren können nicht gelöscht werden, da mindestens einer davon Artikeln zugeordnet ist.",
        "Nie można uzupełnić danych linku. Otwórz okno linku ponownie.": "Die Linkdaten konnten nicht vervollständigt werden. Öffnen Sie das Linkfenster erneut.",
        "Nie pokazuj krótkiego opisu strony w wynikach wyszukiwania (NoSnippet)": "Die Kurzbeschreibung der Seite nicht in den Suchergebnissen anzeigen (NoSnippet)",
        "Nie pokazuj linku do archiwum strony (NoArchive)": "Keinen Link zum Seitenarchiv anzeigen (NoArchive)",
        "Nie pokazuj strony jako źródła grafiki w wynikach wyszukiwania (NoImageIndex)": "Die Seite in den Suchergebnissen nicht als Bildquelle anzeigen (NoImageIndex)",
        "Nie pomocna": "Nicht hilfreich",
        "Nie posiadasz uprawnień do edycji tego artykułu.": "Sie sind nicht berechtigt, diesen Artikel zu bearbeiten.",
        "Nie udało się dodać widgetu do aranżacji.": "Das Widget konnte dem Layout nicht hinzugefügt werden.",
        "Nie udało się odświeżyć listy zestawów. Spróbuj ponownie.": "Die Liste der Sets konnte nicht aktualisiert werden. Versuchen Sie es erneut.",
        "Nie udało się otworzyć dodawania powiązanego rekordu.": "Das Formular zum Hinzufügen eines verknüpften Datensatzes konnte nicht geöffnet werden.",
        "Nie udało się otworzyć edycji formularza.": "Das Formular zum Bearbeiten konnte nicht geöffnet werden.",
        "Nie udało się otworzyć edycji powiązanego rekordu.": "Das Formular zum Bearbeiten des verknüpften Datensatzes konnte nicht geöffnet werden.",
        "Nie udało się otworzyć formularza": "Das Formular konnte nicht geöffnet werden",
        "Nie udało się otworzyć podglądu aranżacji.": "Die Layoutvorschau konnte nicht geöffnet werden.",
        "Nie udało się oznaczyć zamówienia jako opłacone.": "Die Bestellung konnte nicht als bezahlt markiert werden.",
        "Nie udało się pobrać adresu strony.": "Die Seitenadresse konnte nicht abgerufen werden.",
        "Nie udało się pobrać aranżacji.": "Das Layout konnte nicht abgerufen werden.",
        "Nie udało się pobrać dostępnych aranżacji.": "Die verfügbaren Layouts konnten nicht abgerufen werden.",
        "Nie udało się pobrać listy aranżacji": "Die Layoutliste konnte nicht abgerufen werden",
        "Nie udało się pobrać listy etykiet": "Die Labelliste konnte nicht abgerufen werden",
        "Nie udało się pobrać listy kategorii": "Die Kategorienliste konnte nicht abgerufen werden",
        "Nie udało się pobrać listy modułów": "Die Modulliste konnte nicht abgerufen werden",
        "Nie udało się pobrać listy regulaminów": "Die Liste der Nutzungsbedingungen konnte nicht abgerufen werden",
        "Nie udało się pobrać listy stron": "Die Seitenliste konnte nicht abgerufen werden",
        "Nie udało się pobrać listy witryn.": "Die Liste der Websites konnte nicht abgerufen werden.",
        "Nie udało się pobrać pakietu.": "Das Paket konnte nicht abgerufen werden.",
        "Nie udało się pobrać pełnej listy zestawów.": "Die vollständige Liste der Sets konnte nicht abgerufen werden.",
        "Nie udało się pobrać powiązanych wpisów dla tego widgetu.": "Die verknüpften Einträge für dieses Widget konnten nicht abgerufen werden.",
        "Nie udało się pobrać treści.": "Der Inhalt konnte nicht abgerufen werden.",
        "Nie udało się pobrać ustawień wpisu dla tego widgetu.": "Die Eintragseinstellungen für dieses Widget konnten nicht abgerufen werden.",
        "Nie udało się pobrać witryn.": "Die Websites konnten nicht abgerufen werden.",
        "Nie udało się pobrać wybranych treści.": "Die ausgewählten Inhalte konnten nicht abgerufen werden.",
        "Nie udało się pobrać wyników ankiety. Spróbuj ponownie.": "Die Umfrageergebnisse konnten nicht abgerufen werden. Versuchen Sie es erneut.",
        "Nie udało się rozpoznać endpointu schemy formularza.": "Der Endpunkt des Formularschemas konnte nicht ermittelt werden.",
        "Nie udało się skopiować adresu.": "Die Adresse konnte nicht kopiert werden.",
        "Nie udało się skopiować do schowka.": "Der Inhalt konnte nicht in die Zwischenablage kopiert werden.",
        "Nie udało się skopiować widgetu.": "Das Widget konnte nicht kopiert werden.",
        "Nie udało się ustalić powiązanego rekordu.": "Der verknüpfte Datensatz konnte nicht ermittelt werden.",
        "Nie udało się ustalić źródła powiązanego rekordu.": "Die Quelle des verknüpften Datensatzes konnte nicht ermittelt werden.",
        "Nie udało się ustalić źródła powiązanych rekordów.": "Die Quelle der verknüpften Datensätze konnte nicht ermittelt werden.",
        "Nie udało się ustawić aranżacji domyślnej": "Das Standardlayout konnte nicht festgelegt werden",
        "Nie udało się wczytać danych klienta.": "Die Kundendaten konnten nicht geladen werden.",
        "Nie udało się wczytać grupy banerów.": "Die Bannergruppe konnte nicht geladen werden.",
        "Nie udało się wczytać kanałów RSS": "Die RSS-Feeds konnten nicht geladen werden",
        "Nie udało się wczytać klientów.": "Die Kunden konnten nicht geladen werden.",
        "Nie udało się wczytać komentarzy.": "Die Kommentare konnten nicht geladen werden.",
        "Nie udało się wczytać przekierowań.": "Die Weiterleitungen konnten nicht geladen werden.",
        "Nie udało się wczytać sitemap. Spróbuj ponownie.": "Die Sitemap konnte nicht geladen werden. Versuchen Sie es erneut.",
        "Nie udało się wczytać szablonów.": "Die Vorlagen konnten nicht geladen werden.",
        "Nie udało się wczytać ustawień": "Die Einstellungen konnten nicht geladen werden",
        "Nie udało się wczytać ustawień komentarzy.": "Die Kommentareinstellungen konnten nicht geladen werden.",
        "Nie udało się wczytać ustawień RSS": "Die RSS-Einstellungen konnten nicht geladen werden",
        "Nie udało się wczytać ustawień RSS. Spróbuj ponownie.": "Die RSS-Einstellungen konnten nicht geladen werden. Versuchen Sie es erneut.",
        "Nie udało się wczytać ustawień sitemap.": "Die Sitemap-Einstellungen konnten nicht geladen werden.",
        "Nie udało się wczytać ustawień witryny.": "Die Website-Einstellungen konnten nicht geladen werden.",
        "Nie udało się wczytać widgetu.": "Das Widget konnte nicht geladen werden.",
        "Nie udało się wczytać witryn.": "Die Websites konnten nicht geladen werden.",
        "Nie udało się wczytać wszystkich danych kategorii.": "Alle Kategoriedaten konnten nicht geladen werden.",
        "Nie udało się wczytać wzorów shortcode.": "Die Shortcode-Vorlagen konnten nicht geladen werden.",
        "Nie udało się wczytać wzoru shortcode.": "Die Shortcode-Vorlage konnte nicht geladen werden.",
        "Nie udało się wczytać zamówień.": "Die Bestellungen konnten nicht geladen werden.",
        "Nie udało się wczytać zamówienia.": "Die Bestellung konnte nicht geladen werden.",
        "Nie udało się wczytać zgłoszeń": "Die Tickets konnten nicht geladen werden",
        "Nie udało się wczytać zgłoszeń. Spróbuj ponownie.": "Die Tickets konnten nicht geladen werden. Versuchen Sie es erneut.",
        "Nie udało się wczytać zgód": "Die Einwilligungen konnten nicht geladen werden",
        "Nie udało się wyeksportować przekierowań.": "Die Weiterleitungen konnten nicht exportiert werden.",
        "Nie udało się wygenerować stron gazetki.": "Die Seiten des Prospekts konnten nicht generiert werden.",
        "Nie udało się zaimportować przekierowań.": "Die Weiterleitungen konnten nicht importiert werden.",
        "Nie udało się zaktualizować wybranych aranżacji.": "Die ausgewählten Layouts konnten nicht aktualisiert werden.",
        "Nie udało się załadować podglądu.": "Die Vorschau konnte nicht geladen werden.",
        "Nie udało się zapisać grupy banerów.": "Die Bannergruppe konnte nicht gespeichert werden.",
        "Nie udało się zapisać ustawień. Sprawdź wartości i spróbuj ponownie.": "Die Einstellungen konnten nicht gespeichert werden. Überprüfen Sie die Werte und versuchen Sie es erneut.",
        "Nie udało się zapisać zmiany.": "Die Änderung konnte nicht gespeichert werden.",
        "Nie udało się zduplikować widgetu.": "Das Widget konnte nicht dupliziert werden.",
        "Nie udało się zlecić generowania sitemap.": "Die Generierung der Sitemap konnte nicht in Auftrag gegeben werden.",
        "Nie wybrano authora.": "Es wurde kein Autor ausgewählt.",
        "Nie wybrano autora.": "Es wurde kein Autor ausgewählt.",
        "Nie wybrano jeszcze żadnego regulaminu. Wyszukaj regulamin powyżej i dodaj go do zestawu.": "Sie haben noch keine Nutzungsbedingungen ausgewählt. Suchen Sie oben nach Nutzungsbedingungen und fügen Sie sie zum Paket hinzu.",
        "Nie wybrano strony": "Es wurde keine Seite ausgewählt",
        "Nie wybrano żadnej kategorii": "Es wurde keine Kategorie ausgewählt",
        "Nie wybrano żadnej strony.": "Es wurde keine Seite ausgewählt.",
        "Nie zdefiniowano żadnych sekcji.": "Es wurden keine Abschnitte definiert.",
        "Nie znaleziono edytowalnych pól w aktualnym podglądzie.": "In der aktuellen Vorschau wurden keine bearbeitbaren Felder gefunden.",
        "Nie znaleziono opublikowanej aranżacji.": "Es wurde kein veröffentlichtes Layout gefunden.",
        "Nie znaleziono problemów.": "Es wurden keine Probleme gefunden.",
        "Nie znaleziono widocznego elementu tego pola w aktualnym DOM podglądu.": "Im aktuellen DOM der Vorschau wurde kein sichtbares Element für dieses Feld gefunden.",
        "Nie znaleziono żadnych folderów.": "Es wurden keine Ordner gefunden.",
        "Nie związana": "Nicht zugeordnet",
        "Nieaktywna": "Inaktiv",
        "Nieaktywne": "Inaktiv",
        "Nieaktywny": "Inaktiv",
        "Niedostępny widżet może być wyłączony dla witryny lub już użyty jako unikalny element.": "Das nicht verfügbare Widget ist möglicherweise für die Website deaktiviert oder wird bereits als eindeutiges Element verwendet.",
        "Niedozwolone słowa": "Unzulässige Wörter",
        "Niedziela": "Sonntag",
        "Nieformalny": "Informell",
        "niejednoznaczne": "mehrdeutig",
        "Niejednoznaczne": "Mehrdeutig",
        "Niemiecki": "Deutsch",
        "Nieobsługiwane pole edycji inline.": "Nicht unterstütztes Inline-Bearbeitungsfeld.",
        "Nieopłacone": "Unbezahlt",
        "Niepotwierdzona": "Nicht bestätigt",
        "Niestandardowy adres": "Benutzerdefinierte Adresse",
        "Niestandardowy adres strony": "Benutzerdefinierte Seitenadresse",
        "Niestandardowy nagłówek": "Benutzerdefinierte Überschrift",
        "Nieudana próba doręczenia": "Zustellung fehlgeschlagen",
        "Niezapisane zmiany:": "Nicht gespeicherte Änderungen:",
        "Nieznany status": "Unbekannter Status",
        "Nigdy": "Nie",
        "NIP": "Steueridentifikationsnummer",
        "Niski": "Niedrig",
        "Niżej": "Weiter unten",
        "Nofollow": "Nofollow",
        "Nowa": "Neu",
        "Nowa aktualność": "Neue Meldung",
        "Nowa aranżacja": "Neues Layout",
        "Nowa cena brutto": "Neuer Bruttopreis",
        "Nowa cena do": "Neuer Preis bis",
        "Nowa cena od": "Neuer Preis ab",
        "Nowa cena zacznie obowiązywać w podanym okresie.": "Der neue Preis gilt im angegebenen Zeitraum.",
        "Nowa kategoria": "Neue Kategorie",
        "Nowe pytanie": "Neue Frage",
        "Nowy artykuł": "Neuer Artikel",
        "Nowy autor": "Neuer Autor",
        "Nowy widżet": "Neues Widget",
        "np. _blank": "z. B. _blank",
        "np. 7": "z. B. 7",
        "np. Banner e-commerce": "z. B. E-Commerce-Banner",
        "np. Czołówka Technologia": "z. B. Technologie-Header",
        "np. E-commerce": "z. B. E-Commerce",
        "np. pim": "z. B. pim",
        "np. pl-PL": "z. B. pl-PL",
        "np. poradnik": "z. B. Ratgeber",
        "np. Poradniki": "z. B. Ratgeber",
        "np. Spam": "z. B. Spam",
        "np. Trwają prace serwisowe": "z. B. Wartungsarbeiten laufen",
        "np. wyrażenie": "z. B. Ausdruck",
        "np. Zenon Mącugowski": "z. B. Zenon Mącugowski",
        "Numer": "Nummer",
        "Numer aktywnej strony": "Nummer der aktiven Seite",
        "Numer telefonu": "Telefonnummer",
        "Obraz": "Bild",
        "Obrazy bez wymiarów": "Bilder ohne Abmessungen",
        "Obrazy: automatycznie": "Bilder: automatisch",
        "Obrazy: zawsze leniwie": "Bilder: immer verzögert laden",
        "Obrazy: zawsze natychmiast": "Bilder: immer sofort laden",
        "Obsługiwane są wyłącznie linki wewnętrzne": "Es werden nur interne Links unterstützt",
        "Obszary aktywne": "Aktive Bereiche",
        "Ochrona przed spamem": "Spamschutz",
        "Oczekujące": "Ausstehend",
        "Oczekujący na akceptację": "Wartet auf Freigabe",
        "Oczekuje na akceptację": "Wartet auf Freigabe",
        "Oczekuje na płatność": "Wartet auf Zahlung",
        "Oczekuje na potwierdzenie": "Wartet auf Bestätigung",
        "Oczekuje na weryfikację": "Wartet auf Überprüfung",
        "Oczekuje na wysyłkę": "Wartet auf den Versand",
        "Oczekuje na zatwierdzenie": "Wartet auf Genehmigung",
        "Od 1 do 50 najnowszych pozycji w każdym kanale RSS. Ustawienie dotyczy wszystkich witryn.": "Von 1 bis 50 der neuesten Einträge in jedem RSS-Feed. Die Einstellung gilt für alle Websites.",
        "Od poziomu": "Ab Ebene",
        "Odczyt tylko po zalogowaniu": "Lesen nur nach der Anmeldung",
        "Odebrane w punkcie": "Abgeholt an der Abholstelle",
        "Odepnij": "Lösen",
        "Odepnij od widżetu": "Vom Widget lösen",
        "Odnośnik": "Link",
        "Odnośnik do informacji o plikach cookies.": "Link zu Informationen über Cookies.",
        "Odnośnik do informacji o przetwarzaniu danych osobowych.": "Link zu Informationen über die Verarbeitung personenbezogener Daten.",
        "Odnośnik do innej strony w serwisie": "Link zu einer anderen Seite der Website",
        "Odnośnik do strony w serwisie": "Link zu einer Seite der Website",
        "Odnośnik do zewnętrznego adresu": "Link zu einer externen Adresse",
        "Odnośnik URL": "URL-Link",
        "Odnośniki": "Links",
        "Odpięto dev details": "Dev-Details gelöst",
        "Odpowiedź": "Antwort",
        "Odpowiedź {number}": "Antwort {number}",
        "Odpowiedzi": "Antworten",
        "Odrzuć": "Ablehnen",
        "Odrzuć zmiany": "Änderungen verwerfen",
        "Odrzucone": "Abgelehnt",
        "Odrzucone zgody": "Abgelehnte Einwilligungen",
        "Odrzucony po zgłoszeniach": "Nach Meldungen abgelehnt",
        "Odśwież": "Aktualisieren",
        "Odśwież podgląd": "Vorschau aktualisieren",
        "Odśwież wybór witryny i spróbuj ponownie.": "Aktualisieren Sie die Website-Auswahl und versuchen Sie es erneut.",
        "Odświeżam podgląd formularza...": "Formularvorschau wird aktualisiert...",
        "Odświeżam podgląd po dodaniu treści...": "Vorschau nach dem Hinzufügen von Inhalten wird aktualisiert...",
        "Odświeżam podgląd...": "Vorschau wird aktualisiert...",
        "Odświeżono": "Aktualisiert",
        "Odświeżono schemę formularza": "Formularschema aktualisiert",
        "Odznacz wszystkie": "Alle abwählen",
        "Ogólny": "Allgemein",
        "Ograniczenia długości komentarzy.": "Begrenzung der Kommentarlänge.",
        "Okładka": "Titelbild",
        "Okładka do wideo premium": "Titelbild für Premium-Video",
        "Okładka oraz pliki PDF źródłowy i do pobrania.": "Titelbild sowie Quelldatei und herunterladbare PDF-Datei.",
        "Okres, w którym temat jest widoczny.": "Zeitraum, in dem das Thema sichtbar ist.",
        "Określ dostępność witryny oraz sposób dostępu do jej treści.": "Legen Sie die Verfügbarkeit der Website und den Zugriff auf ihre Inhalte fest.",
        "Określ zasady odkrywania treści i ich użycia przez dostawców AI.": "Legen Sie fest, wie Inhalte von KI-Anbietern gefunden und genutzt werden dürfen.",
        "Określ, jak aktywowane są konta zakładane przez rejestrację.": "Legen Sie fest, wie Konten aktiviert werden, die über die Registrierung erstellt wurden.",
        "Określ, kto może wyświetlić stronę.": "Legen Sie fest, wer die Seite anzeigen kann.",
        "Określa z której strony do ścieżki mają być dodawane kolejne pozycje.": "Legt fest, an welcher Seite des Pfads weitere Einträge hinzugefügt werden.",
        "Określa, od kiedy komunikat ma być widoczny na stronie.": "Legt fest, ab wann die Meldung auf der Seite sichtbar sein soll.",
        "Opcje linku": "Linkoptionen",
        "Opcje modułu przypisanego do tej strony.": "Optionen des dieser Seite zugeordneten Moduls.",
        "Opcjonalne zdjęcie używane jako tło treści.": "Optionales Bild, das als Hintergrund für den Inhalt verwendet wird.",
        "Open Graph": "Open Graph",
        "Operator płatności": "Zahlungsanbieter",
        "Opinia": "Bewertung",
        "Opinia autora": "Autorenmeinung",
        "Opinie": "Bewertungen",
        "Opis": "Beschreibung",
        "Opis przerwy technicznej": "Beschreibung der Wartungsarbeiten",
        "Opis sekcji": "Abschnittsbeschreibung",
        "Opis witryny": "Website-Beschreibung",
        "Opis wyświetlany pod odtwarzaczem": "Beschreibung, die unter dem Player angezeigt wird",
        "Opisz, co mam napisać": "Beschreiben Sie, was ich schreiben soll",
        "Opłacone": "Bezahlt",
        "Opublikował": "Veröffentlicht von",
        "Opublikowana": "Veröffentlicht",
        "Opublikowane": "Veröffentlicht",
        "Opublikowane języki": "Veröffentlichte Sprachen",
        "Opublikowane wersje językowe.": "Veröffentlichte Sprachversionen.",
        "Opublikowany na stronach": "Auf Websites veröffentlicht",
        "Opublikuj": "Veröffentlichen",
        "Opublikuj autora": "Autor veröffentlichen",
        "Origin formularza": "Formular-Origin",
        "Oś czasu": "Zeitleiste",
        "Osobne warianty dla różnych szerokości ekranu.": "Separate Varianten für unterschiedliche Bildschirmbreiten.",
        "Osoby podpisane pod artykułem": "Am Artikel beteiligte Personen",
        "Ostatni miesiąc": "Letzter Monat",
        "Ostatni rok": "Letztes Jahr",
        "Ostatni tydzień": "Letzte Woche",
        "Ostatnia aktualizacja:": "Letzte Aktualisierung:",
        "Ostrzeżenia": "Warnungen",
        "ostrzeżenie": "Warnung",
        "Otwiera się pod głównym adresem witryny. Dla danego języka może istnieć tylko jedna.": "Wird unter der Hauptadresse der Website geöffnet. Pro Sprache ist nur eine möglich.",
        "Otwieraj w nowym oknie": "In neuem Fenster öffnen",
        "Otwórz edytor": "Editor öffnen",
        "Otwórz podgląd llms.txt": "llms.txt-Vorschau öffnen",
        "Otwórz podgląd llms.txt i sprawdź opublikowaną zawartość.": "Öffnen Sie die llms.txt-Vorschau und prüfen Sie den veröffentlichten Inhalt.",
        "Otwórz podgląd robots.txt": "robots.txt-Vorschau öffnen",
        "Otwórz stronę w nowym oknie": "Seite in neuem Fenster öffnen",
        "Otwórz w nowej karcie": "In neuem Tab öffnen",
        "Otworzono dodawanie wpisu": "Hinzufügen eines Beitrags geöffnet",
        "Otworzono edytor wpisu": "Beitragseditor geöffnet",
        "Otworzono formularz": "Formular geöffnet",
        "Oznacz jako opłacone": "Als bezahlt markieren",
        "Oznacza artykuł jako materiał sponsorowany.": "Kennzeichnet den Artikel als gesponserten Inhalt.",
        "Oznacza artykuł jako opinię autora.": "Kennzeichnet den Artikel als Autorenmeinung.",
        "Oznacza tę witrynę jako główną w systemie.": "Kennzeichnet diese Website im System als Hauptwebsite.",
        "Oznacza treść jako dostępną w ramach premium.": "Kennzeichnet den Inhalt als Premium-Inhalt.",
        "Pakiet": "Paket",
        "Pakiet aktywny": "Paket aktiv",
        "Pakiet autoodnawialny": "Paket mit automatischer Verlängerung",
        "Pakiet debugowy skopiowany do schowka.": "Debug-Paket in die Zwischenablage kopiert.",
        "Pakiety": "Pakete",
        "Parametry email": "E-Mail-Parameter",
        "PayU": "PayU",
        "Pełna strona": "Vollständige Seite",
        "Pełna szerokość": "Volle Breite",
        "Pełny adres aktywnej strony": "Vollständige Adresse der aktiven Seite",
        "Pełny adres wraz z \"http(s)://\".": "Vollständige Adresse einschließlich \"http(s)://\".",
        "Piątek": "Freitag",
        "Pierwsza strona z listy jest identyfikowana przez system jako CANONICAL, czyli informuje roboty wyszukiwarki, która ze zduplikowanych stron jest tą z oryginalną treścią.": "Die erste Seite in der Liste wird vom System als CANONICAL identifiziert. Damit wird den Suchmaschinen-Crawlern mitgeteilt, welche der duplizierten Seiten den Originalinhalt enthält.",
        "Pierwsze powiadomienie": "Erste Benachrichtigung",
        "Pierwsze zdjęcie jest okładką galerii. Kolejność zmienisz przeciąganiem.": "Das erste Bild ist das Titelbild der Galerie. Die Reihenfolge können Sie durch Ziehen ändern.",
        "Pierwsze zdjęcie w galerii jest zdjęciem głównym": "Das erste Bild in der Galerie ist das Hauptbild",
        "Piosenka": "Lied",
        "Pisać mogą tylko zalogowani użytkownicy": "Nur angemeldete Benutzer können schreiben",
        "Płatność": "Zahlung",
        "Płatności cykliczne": "Wiederkehrende Zahlungen",
        "Płeć": "Geschlecht",
        "Plik": "Datei",
        "Plik gazetki (PDF)": "Datei des Newsletters (PDF)",
        "Plik gazetki do pobrania (PDF)": "Herunterladbare Newsletter-Datei (PDF)",
        "Plik graficzny": "Bilddatei",
        "Plik llms.txt": "llms.txt-Datei",
        "Plik wideo": "Videodatei",
        "Plik z repozytorium albo adres URL": "Datei aus einem Repository oder URL",
        "Pliki do pobrania dostępne w ramach treści premium.": "Downloads, die im Rahmen von Premium-Inhalten verfügbar sind.",
        "Pliki do pobrania pod wpisem": "Downloads unter dem Beitrag",
        "Pliki dokumentu": "Dokumentdateien",
        "Pliki dostępne do pobrania przy artykule.": "Dateien, die beim Artikel zum Download verfügbar sind.",
        "Pliki gazetki": "Newsletter-Dateien",
        "Płyta z muzyką": "Musik-CD",
        "Po aktywacji odwiedzający zobaczą komunikat o przerwie technicznej. Użytkownicy z uprawnieniami administratora nadal mają dostęp do witryny.": "Nach der Aktivierung sehen Besucher eine Meldung über Wartungsarbeiten. Benutzer mit Administratorberechtigungen haben weiterhin Zugriff auf die Website.",
        "Po otwarciu listy widzisz pierwsze wyniki. Wpisz początek wartości z pola identyfikującego, aby zawęzić listę.": "Nach dem Öffnen der Liste werden die ersten Ergebnisse angezeigt. Geben Sie den Anfang des Werts aus dem Identifikationsfeld ein, um die Liste einzugrenzen.",
        "Po potwierdzeniu e-maila konto wymaga zatwierdzenia przez administratora.": "Nach der Bestätigung der E-Mail-Adresse muss das Konto von einem Administrator freigegeben werden.",
        "Po przekroczeniu komentarz trafia do moderacji.": "Bei Überschreitung wird der Kommentar zur Moderation weitergeleitet.",
        "Po tym czasie nieopłacone zamówienie wygasa.": "Nach Ablauf dieser Zeit verfällt die unbezahlte Bestellung.",
        "Po zakończeniu subskrypcji": "Nach Ablauf des Abonnements",
        "Po zapisaniu artykułu w wybranej wersji językowej, nie będzie możliwości jej zmiany.": "Nach dem Speichern des Artikels in der ausgewählten Sprachversion kann diese nicht mehr geändert werden.",
        "Po zapisaniu nie można jej zmienić.": "Nach dem Speichern kann sie nicht mehr geändert werden.",
        "Po zapisie rekord będzie dostępny w edytorze powiązań Live Design.": "Nach dem Speichern ist der Datensatz im Verknüpfungseditor von Live Design verfügbar.",
        "Pobieranie płatności dla subskrypcji autoodnawialnych.": "Einziehen von Zahlungen für Abonnements mit automatischer Verlängerung.",
        "Pobierz wyniki": "Ergebnisse herunterladen",
        "Poczta": "Post",
        "Pod spodem nadal masz otwarty podgląd aranżacji.": "Darunter ist weiterhin die Vorschau des Layouts geöffnet.",
        "Podaj adres docelowy i sposób otwierania odnośnika.": "Geben Sie die Zieladresse und die Art des Öffnens des Links an.",
        "Podaj adres url...": "Geben Sie die URL ein...",
        "Podaj identyfikatory administratorów Facebooka, oddzielając je przecinkami.": "Geben Sie die Facebook-Administrator-IDs durch Kommas getrennt ein.",
        "Podaj liczbę całkowitą od 1 do 50.": "Geben Sie eine ganze Zahl von 1 bis 50 ein.",
        "Podaj pełny adres wraz z protokołem.": "Geben Sie die vollständige Adresse einschließlich Protokoll ein.",
        "Podaj poprawny adres e-mail.": "Geben Sie eine gültige E-Mail-Adresse ein.",
        "Podaj temat, długość i ton tekstu…": "Geben Sie Thema, Länge und Ton des Textes an…",
        "Podążanie za linkami": "Links folgen",
        "Podgląd": "Vorschau",
        "Podgląd aranżacji": "Layoutvorschau",
        "Podgląd artykułu": "Artikelvorschau",
        "Podgląd JSON": "JSON-Vorschau",
        "Podgląd Open Graph": "Open-Graph-Vorschau",
        "Podgląd opublikowanej wersji aranżacji.": "Vorschau der veröffentlichten Layoutversion.",
        "Podgląd otwiera aktualnie opublikowany plik. Przy wyłączonej publikacji plik jest niedostępny. Tytuły i opisy zmienisz w treściach lub metadanych CMS — plik powstaje przy otwieraniu i nie wymaga ponownego generowania.": "Die Vorschau öffnet die aktuell veröffentlichte Datei. Wenn die Veröffentlichung deaktiviert ist, ist die Datei nicht verfügbar. Titel und Beschreibungen können Sie in den Inhalten oder CMS-Metadaten ändern — die Datei wird beim Öffnen erstellt und muss nicht erneut generiert werden.",
        "Podgląd pokazuje zapisane reguły. Zapisz witrynę, aby sprawdzić wprowadzone zmiany.": "Die Vorschau zeigt die gespeicherten Regeln. Speichern Sie die Website, um die vorgenommenen Änderungen zu überprüfen.",
        "Podgląd strony": "Seitenvorschau",
        "Podgląd w mediach społecznościowych.": "Vorschau in sozialen Medien.",
        "Podgląd wartości pola": "Vorschau des Feldwerts",
        "Podgląd wersji roboczej aranżacji.": "Vorschau der Layoutentwurfsversion.",
        "Podgląd został odświeżony, ale schema formularza nie zmieniła się. Sprawdź, czy zapisana wersja jest tą, którą zwraca endpoint schemy.": "Die Vorschau wurde aktualisiert, aber das Formularschema hat sich nicht geändert. Prüfen Sie, ob die gespeicherte Version der vom Schema-Endpunkt zurückgegebenen Version entspricht.",
        "Podłącz linki": "Links verknüpfen",
        "Podłącz linki wewnętrzne": "Interne Links verknüpfen",
        "Podpis schemy": "Schema-Signatur",
        "Podstawowe": "Grundlegend",
        "Podstawowe informacje": "Grundlegende Informationen",
        "Podwójna linia ciągła": "Doppelte durchgezogene Linie",
        "Pojedyncza publikacja": "Einzelveröffentlichung",
        "Pojedyńcza, prosta, ciągła linia": "Einfache, durchgezogene Linie",
        "Pojedynczy artykuł (strona opisowa)": "Einzelner Artikel (Beschreibungsseite)",
        "Pokaż etykietę": "Beschriftung anzeigen",
        "Pokaż niedostępne widgety": "Nicht verfügbare Widgets anzeigen",
        "Pokaż skróty": "Tastenkombinationen anzeigen",
        "Pokaż w podglądzie": "In der Vorschau anzeigen",
        "Pokaż więcej": "Mehr anzeigen",
        "Pokazuj niedostępne widżety": "Nicht verfügbare Widgets anzeigen",
        "Pokazuje samą treść artykułu, bez dodatkowej oprawy.": "Zeigt nur den Inhalt des Artikels ohne zusätzliches Layout.",
        "Pola": "Felder",
        "Pola wypełniane podczas wstawiania shortcode.": "Felder, die beim Einfügen des Shortcodes ausgefüllt werden.",
        "Pole \"%0\" jest wymagane.": "Das Feld \"%0\" ist erforderlich.",
        "Pole \"Ilość dni przed\" jest wymagane.": "Das Feld \"Anzahl der Tage zuvor\" ist erforderlich.",
        "Pole \"Język\" jest wymagane.": "Das Feld \"Sprache\" ist erforderlich.",
        "Pole \"Metryka\" jest wymagane.": "Das Feld \"Metrik\" ist erforderlich.",
        "Pole \"Nazwa\" jest wymagane.": "Das Feld \"Name\" ist erforderlich.",
        "Pole \"Sortuj według\" jest wymagane.": "Das Feld \"Sortieren nach\" ist erforderlich.",
        "Pole \"Witryna\" jest wymagane.": "Das Feld \"Website\" ist erforderlich.",
        "Pole \"Wymiar\" jest wymagane.": "Das Feld \"Abmessung\" ist erforderlich.",
        "Pole identyfikujące dokument": "Feld zur Identifizierung des Dokuments",
        "Pole jest puste.": "Das Feld ist leer.",
        "Pole jest widoczne, ale kliknięcie prowadzi do edytora formularzowego.": "Das Feld ist sichtbar, aber ein Klick öffnet den Formular-Editor.",
        "Pole jest widoczne, ale nie ma osobnego klikalnego targetu inline. Otworzy się edytor formularzowy.": "Das Feld ist sichtbar, verfügt aber über kein eigenes anklickbares Inline-Ziel. Der Formular-Editor wird geöffnet.",
        "Pole można edytować bezpośrednio w podglądzie.": "Das Feld kann direkt in der Vorschau bearbeitet werden.",
        "Pole nie ma widocznego elementu w aktualnym podglądzie.": "Das Feld hat in der aktuellen Vorschau kein sichtbares Element.",
        "Pole pasuje do kilku elementów w podglądzie. Wybierz target ręcznie w Live Design.": "Das Feld passt zu mehreren Elementen in der Vorschau. Wählen Sie das Ziel manuell in Live Design aus.",
        "Polski": "Polnisch",
        "Polubienia": "Gefällt mir",
        "Polubienia tylko po zalogowaniu": "Gefällt mir nur nach der Anmeldung",
        "Pomoc": "Hilfe",
        "Pomocna": "Hilfreich",
        "Ponawianie...": "Wird erneut versucht...",
        "Poniedziałek": "Montag",
        "Ponów": "Wiederholen",
        "Ponów ostatnią cofniętą zmianę inline": "Letzte rückgängig gemachte Inline-Änderung wiederholen",
        "Ponowiono operację na widgetu": "Widget-Vorgang wiederholt",
        "Popraw błędy ortograficzne i interpunkcyjne": "Rechtschreib- und Interpunktionsfehler korrigieren",
        "Popraw literówki, zachowaj oryginalny styl": "Tippfehler korrigieren, den ursprünglichen Stil beibehalten",
        "Popraw merytorycznie": "Inhaltlich korrigieren",
        "Popraw nieścisłości i uprość sformułowania": "Ungenauigkeiten korrigieren und Formulierungen vereinfachen",
        "Popraw odmianę i zgodność form gramatycznych": "Deklination und grammatische Übereinstimmung korrigieren",
        "Poprzedni okres": "Vorheriger Zeitraum",
        "Poprzednie pole": "Vorheriges Feld",
        "Popularność": "Beliebtheit",
        "Porównanie wersji": "Versionsvergleich",
        "Porównano pola formularza": "Formularfelder verglichen",
        "Potwierdź": "Bestätigen",
        "Potwierdź akceptację": "Freigabe bestätigen",
        "Potwierdź oznaczenie zamówienia jako opłacone.": "Bestätigen Sie, dass die Bestellung als bezahlt markiert werden soll.",
        "Potwierdź przywrócenie wersji roboczej": "Wiederherstellung des Entwurfs bestätigen",
        "Potwierdź usunięcie": "Löschen bestätigen",
        "Potwierdź usunięcie regulaminu {name}": "Löschen der Nutzungsbedingungen {name} bestätigen",
        "Potwierdź usunięcie slajdu {number}": "Löschen der Folie {number} bestätigen",
        "Potwierdź usunięcie zestawu {name}": "Löschen des Sets {name} bestätigen",
        "Potwierdzenie mailowe": "Bestätigung per E-Mail",
        "Potwierdzenie mailowe i akceptacja administratora": "Bestätigung per E-Mail und Freigabe durch den Administrator",
        "Potwierdzenie przywrócenia": "Wiederherstellung bestätigen",
        "Potwierdzenie usunięcia": "Löschen bestätigen",
        "Potwierdzenie wysłania": "Versandbestätigung",
        "Potwierdzenie zatwierdzenia": "Genehmigung bestätigen",
        "Potwierdzenie zmiany statusu": "Statusänderung bestätigen",
        "Potwierdzone": "Bestätigt",
        "Powiadomienia": "Benachrichtigungen",
        "Powiązana galeria": "Verknüpfte Galerie",
        "Powiązana kategoria": "Verknüpfte Kategorie",
        "Powiązane artykuły": "Verknüpfte Artikel",
        "Powiązane galerie": "Verknüpfte Galerien",
        "Powiązane kategorie": "Verknüpfte Kategorien",
        "Powiązane opinie": "Verknüpfte Bewertungen",
        "Powiązane rekordy": "Verknüpfte Datensätze",
        "Powiązane wideo": "Verknüpfte Videos",
        "Powiązanie": "Verknüpfung",
        "Powiązany artykuł": "Verknüpfter Artikel",
        "Powiązany autor": "Verknüpfter Autor",
        "Powiązany obiekt": "Verknüpftes Objekt",
        "Powód": "Grund",
        "Powody zgłoszeń": "Meldegründe",
        "Powrót": "Zurück",
        "poza DOM": "außerhalb des DOM",
        "Poza DOM": "Außerhalb des DOM",
        "Pozostałe ustawienia": "Weitere Einstellungen",
        "Pozostaw puste, aby nie ustawiać daty końcowej.": "Leer lassen, um kein Enddatum festzulegen.",
        "Pozostaw puste, jeśli komunikat nie ma daty końcowej.": "Leer lassen, wenn die Meldung kein Enddatum hat.",
        "Pozwala dostawcom AI pobierać treści do uczenia modeli i uzupełniania odpowiedzi. Reguła jest zapisywana w robots.txt, niezależnie od publikacji llms.txt.": "Ermöglicht KI-Anbietern, Inhalte zum Trainieren von Modellen und zum Ergänzen von Antworten abzurufen. Die Regel wird unabhängig von der Veröffentlichung von llms.txt in robots.txt gespeichert.",
        "Pozwala robotom wyszukiwarek AI przeglądać treści witryny. Reguła trafia automatycznie do robots.txt po zapisaniu witryny.": "Ermöglicht KI-Suchmaschinenrobotern, die Website-Inhalte zu crawlen. Die Regel wird nach dem Speichern der Website automatisch in robots.txt übernommen.",
        "Pozwala użytkownikom przekazywać komentarze do moderacji.": "Ermöglicht Benutzern, Kommentare zur Moderation einzureichen.",
        "Pozycje z lewej": "Elemente links",
        "Pozycje z prawej": "Elemente rechts",
        "Premiera": "Premiere",
        "Premium": "Premium",
        "Premium otwarty": "Premium geöffnet",
        "Prezentacja": "Präsentation",
        "Priorytet": "Priorität",
        "Priorytet (priority)": "Priorität (priority)",
        "Priorytet publikacji": "Veröffentlichungspriorität",
        "Produkcyjne": "Produktiv",
        "Profil użytkownika": "Benutzerprofil",
        "Projekt aranżacji": "Gestaltungsentwurf",
        "Proporcja {ratio} : 1": "Seitenverhältnis {ratio} : 1",
        "Propozycja": "Vorschlag",
        "Prosty": "Einfach",
        "Protokół OAuth - clientId": "OAuth-Protokoll – clientId",
        "Protokół OAuth - clientSecret": "OAuth-Protokoll – clientSecret",
        "Przechowywanie danych witryny w pamięci podręcznej.": "Website-Daten im Cache speichern.",
        "Przeciągnij autorów, aby ustalić kolejność ich wyświetlania na stronie.": "Ziehen Sie die Autoren, um ihre Anzeigereihenfolge auf der Seite festzulegen.",
        "Przeciągnij kategorie, aby ustalić kolejność ich wyświetlania na stronie.": "Ziehen Sie die Kategorien, um ihre Anzeigereihenfolge auf der Seite festzulegen.",
        "Przeciągnij pakiety, aby ustalić kolejność ich wyświetlania.": "Ziehen Sie die Pakete, um ihre Anzeigereihenfolge festzulegen.",
        "Przeciągnij tutaj widget z biblioteki.": "Ziehen Sie ein Widget aus der Bibliothek hierher.",
        "Przeciągnij widżet do sekcji lub kliknij, aby wybrać miejsce i skonfigurować jego treść.": "Ziehen Sie das Widget in einen Abschnitt oder klicken Sie, um einen Platz auszuwählen und den Inhalt zu konfigurieren.",
        "Przeciągnij, aby zmienić kolejność": "Ziehen, um die Reihenfolge zu ändern",
        "Przed zakończeniem subskrypcji": "Vor Ablauf des Abonnements",
        "Przeglądarka": "Browser",
        "Przejdź": "Gehe zu",
        "Przejdź do aranżacji": "Zur Gestaltung wechseln",
        "Przejdź do poprzedniego lub następnego pola inline": "Zum vorherigen oder nächsten Inline-Feld wechseln",
        "Przejść do edycji menu bez zapisywania zmian?": "Zum Bearbeiten des Menüs wechseln, ohne die Änderungen zu speichern?",
        "Przekierowania": "Weiterleitungen",
        "Przekierowanie aktywne": "Weiterleitung aktiv",
        "Przekierowanie zostało usunięte.": "Die Weiterleitung wurde gelöscht.",
        "Przekierowanie zostało zapisane.": "Die Weiterleitung wurde gespeichert.",
        "przekroczony": "überschritten",
        "Przełącz": "Umschalten",
        "Przełączenie na tryb statyczny usunie zdefiniowane sekcje dynamiczne dla tego typu aranżacji.": "Beim Wechsel in den statischen Modus werden die für diesen Gestaltungstyp definierten dynamischen Abschnitte entfernt.",
        "Przenieś artykuł": "Artikel verschieben",
        "Przenieś do sekcji": "In Abschnitt verschieben",
        "Przenieś kategorię niżej": "Kategorie nach unten verschieben",
        "Przenieś kategorię wyżej": "Kategorie nach oben verschieben",
        "Przenieś niżej": "Nach unten verschieben",
        "Przenieś odpowiedź {number}": "Antwort {number} verschieben",
        "Przenieś opinię {number}": "Bewertung {number} verschieben",
        "Przenieś plik": "Datei verschieben",
        "Przenieś później": "Später verschieben",
        "Przenieś pytanie {number}": "Frage {number} verschieben",
        "Przenieś pytanie niżej": "Frage nach unten verschieben",
        "Przenieś pytanie wyżej": "Frage nach oben verschieben",
        "Przenieś sekcję {name}": "Abschnitt {name} verschieben",
        "Przenieś slajd {number} w dół": "Folie {number} nach unten verschieben",
        "Przenieś slajd {number} w górę": "Folie {number} nach oben verschieben",
        "Przenieś treść modułu": "Modulinhalt verschieben",
        "Przenieś wcześniej": "Früher verschieben",
        "Przenieś widżet {name}": "Widget {name} verschieben",
        "Przenieś wyżej": "Nach oben verschieben",
        "Przeniesiono widget": "Widget verschoben",
        "Przepisz zaznaczony fragment i podziel go na akapity": "Den ausgewählten Abschnitt umformulieren und in Absätze unterteilen",
        "Przepisz zaznaczony fragment i skróć go o połowę": "Den ausgewählten Abschnitt umformulieren und auf die Hälfte kürzen",
        "Przepisz zaznaczony fragment, pozostawiając dane i liczby": "Den ausgewählten Abschnitt umformulieren und dabei Daten und Zahlen beibehalten",
        "Przepisz zaznaczony fragment, zachowując jego sens": "Den ausgewählten Abschnitt umformulieren und dabei den Sinn beibehalten",
        "Przeredaguj zaznaczony fragment na bardziej formalny": "Den ausgewählten Abschnitt formeller umformulieren",
        "Przerwa techniczna": "Wartungsarbeiten",
        "Przesuń do góry": "Nach oben verschieben",
        "Przesuń niżej": "Nach unten verschieben",
        "Przesuń w dół": "Nach unten verschieben",
        "Przesuń wyżej": "Nach oben verschieben",
        "Przetłumacz i dostosuj tekst do lokalnego czytelnika": "Übersetzen und den Text an die lokalen Leser anpassen",
        "Przetłumacz zaznaczony fragment w stylu formalnym": "Den ausgewählten Abschnitt in einem formellen Stil übersetzen",
        "Przetłumacz zaznaczony fragment, pozostawiając nazwy własne bez zmian": "Den ausgewählten Abschnitt übersetzen und Eigennamen unverändert lassen",
        "Przetłumacz zaznaczony fragment, zachowując ton wypowiedzi": "Den ausgewählten Abschnitt übersetzen und dabei den Ton beibehalten",
        "Przygotowuję formularz edycji.": "Ich bereite das Bearbeitungsformular vor.",
        "Przypięto dev details": "Dev-Details angeheftet",
        "Przypisz pola tytułu, opisu i daty do klucza modułu Studio. Puste pole pozostawia domyślne mapowanie.": "Weisen Sie die Felder für Titel, Beschreibung und Datum dem Studio-Modulschlüssel zu. Ein leeres Feld behält die Standardzuordnung bei.",
        "Przypnij": "Anheften",
        "Przywróć": "Wiederherstellen",
        "Przywróć kolejność domyślną": "Standardreihenfolge wiederherstellen",
        "Przywróć wszystkie": "Alle wiederherstellen",
        "Pseudonim": "Pseudonym",
        "Publiczne ID": "Öffentliche ID",
        "Publikacja": "Veröffentlichung",
        "Publikacja dokumentu": "Dokumentveröffentlichung",
        "Publikacja galerii przez użytkownika": "Veröffentlichung einer Galerie durch den Benutzer",
        "Publikacja nie gwarantuje użycia treści przez konkretnego dostawcę AI.": "Die Veröffentlichung garantiert nicht, dass der Inhalt von einem bestimmten KI-Anbieter verwendet wird.",
        "Publikacja priorytetowa": "Priorisierte Veröffentlichung",
        "Publikacja strony i jej obecność w menu.": "Veröffentlichung der Seite und ihre Anzeige im Menü.",
        "Publikacja wideo przez użytkownika": "Veröffentlichung eines Videos durch den Benutzer",
        "Publikacja zarchiwizowana": "Archivierte Veröffentlichung",
        "Publikacja została dodana.": "Die Veröffentlichung wurde hinzugefügt.",
        "Publikacja została usunięta.": "Die Veröffentlichung wurde gelöscht.",
        "Publikuj": "Veröffentlichen",
        "Publikuj do": "Veröffentlichen bis",
        "Publikuj llms.txt": "llms.txt veröffentlichen",
        "Publikuj na stronie": "Auf der Website veröffentlichen",
        "Publikuj na wybranej stronie": "Auf der ausgewählten Website veröffentlichen",
        "Publikuj od": "Veröffentlichen ab",
        "Publikuj slajd {number} do": "Folie {number} veröffentlichen bis",
        "Publikuj slajd {number} od": "Folie {number} veröffentlichen ab",
        "Publikuj slajder do": "Slider veröffentlichen bis",
        "Pusta sekcja": "Leerer Abschnitt",
        "puste": "leer",
        "Puste – bez daty końcowej.": "Leer – ohne Enddatum.",
        "Puste = bez daty końcowej.": "Leer = ohne Enddatum.",
        "Pusty układ — zacznij od własnej kompozycji.": "Leeres Layout — beginnen Sie mit Ihrer eigenen Gestaltung.",
        "Pytania i odpowiedzi": "Fragen und Antworten",
        "Pytanie": "Frage",
        "razy": "Mal",
        "Recaptcha": "Recaptcha",
        "Ręczna akceptacja wszystkich komentarzy": "Manuelle Freigabe aller Kommentare",
        "Ręczny wybór zdjęć lub galerii": "Manuelle Auswahl von Fotos oder Galerien",
        "Redakcja": "Redaktion",
        "Redaktor został zaktualizowany.": "Der Redakteur wurde aktualisiert.",
        "Region": "Region",
        "Regulamin wymagany": "Nutzungsbedingungen erforderlich",
        "Regulamin został dodany.": "Die Nutzungsbedingungen wurden hinzugefügt.",
        "Regulamin został zaktualizowany.": "Die Nutzungsbedingungen wurden aktualisiert.",
        "Regulaminy": "Nutzungsbedingungen",
        "Regulaminy z zapisaną datą odrzucenia.": "Nutzungsbedingungen mit gespeichertem Ablehnungsdatum.",
        "Regulaminy zaakceptowane przez użytkownika.": "Vom Benutzer akzeptierte Nutzungsbedingungen.",
        "Reguły wygaśnięcia i anulowania nieopłaconych zamówień.": "Regeln für den Ablauf und die Stornierung unbezahlter Bestellungen.",
        "Rejestracja": "Registrierung",
        "Rejestracja konta": "Kontoregistrierung",
        "Repozytorium": "Repository",
        "Repozytorium plików": "Dateirepository",
        "Reżyseria": "Regie",
        "Robocza": "Entwurf",
        "Roboty nie podążają za tym odnośnikiem.": "Robots folgen diesem Link nicht.",
        "Rodzaj adresu kanonicznego": "Art der kanonischen URL",
        "Rodzaj pozycji menu": "Art des Menüeintrags",
        "Rodzaj strony": "Seitentyp",
        "Rodzaj źródła": "Quelltyp",
        "Rotator": "Slider",
        "Rotator został dodany.": "Der Slider wurde hinzugefügt.",
        "Rotator został usunięty.": "Der Slider wurde gelöscht.",
        "Rotator został zaktualizowany.": "Der Slider wurde aktualisiert.",
        "Rotatory opinii": "Bewertungs-Slider",
        "Rozbudowany": "Erweitert",
        "Rozbuduj i podziel na dwa akapity": "Erweitern und in zwei Absätze unterteilen",
        "Rozbuduj tekst": "Text erweitern",
        "Rozciąga artykuł na pełną szerokość strony.": "Der Artikel wird auf die gesamte Seitenbreite gestreckt.",
        "Rozpoczęcie pobrania płatności przed końcem subskrypcji": "Einzug der Zahlung vor Ablauf des Abonnements starten",
        "Rozwiń akapit o korzyściach dla redakcji": "Den Absatz zu den Vorteilen für die Redaktion erweitern",
        "Rozwiń do": "Erweitern auf",
        "Rozwiń fragment o dwa zdania, zachowując ton wypowiedzi": "Den Abschnitt um zwei Sätze erweitern und dabei den Ton beibehalten",
        "Rozwiń panel podglądu": "Vorschaupanel erweitern",
        "RSS": "RSS",
        "Scenariusz": "Szenario",
        "schema bez zmian": "Schema unverändert",
        "Schema formularza bez zmian": "Formularschema unverändert",
        "schema OK": "Schema OK",
        "schema po refreshu": "Schema nach dem Aktualisieren",
        "Schema URL": "Schema-URL",
        "Ścieżka": "Pfad",
        "Ścieżka aktywnej strony": "Pfad der aktiven Seite",
        "Ścieżka nawigacyjna": "Navigationspfad",
        "ścieżka strony CMS": "Pfad der CMS-Seite",
        "sek.": "Sek.",
        "Sekcja": "Abschnitt",
        "Sekcja %0": "Abschnitt %0",
        "Sekcja aranżacji": "Layoutabschnitt",
        "Sekcja docelowa": "Zielabschnitt",
        "Sekcja komentarzy": "Kommentarbereich",
        "Sekcja modułu": "Modulabschnitt",
        "Sekcja pod artykułem": "Abschnitt unter dem Artikel",
        "Sekcja śródtekstowa": "Textabschnitt",
        "Sekcja wybranego modułu używana przez widżet.": "Der vom Widget verwendete Abschnitt des ausgewählten Moduls.",
        "Sekcje": "Abschnitte",
        "Sekcje szablonu": "Vorlagenabschnitte",
        "Sekcje treści": "Inhaltsabschnitte",
        "Sekcje użytkownika": "Benutzerabschnitte",
        "SEO": "SEO",
        "Separator elementów w tytule": "Trennzeichen zwischen Elementen im Titel",
        "Separator tytułu i generowanie mapy witryny.": "Titeltrennzeichen und Generierung der Sitemap.",
        "Serial telewizyjny": "Fernsehserie",
        "Serie kresek lub fragmentów linii": "Strich- oder Linienfolgen",
        "Serie kropek": "Punktfolgen",
        "Serwis": "Dienst",
        "Shorcode nie istnieje. Usuń go z edytora.": "Der Shortcode existiert nicht. Entfernen Sie ihn aus dem Editor.",
        "Shortcode": "Shortcode",
        "Shortcode testowy": "Test-Shortcode",
        "ShortCode został dodany.": "Der Shortcode wurde hinzugefügt.",
        "Shortcode został usunięty": "Der Shortcode wurde gelöscht",
        "ShortCode został zaktualizowany.": "Der Shortcode wurde aktualisiert.",
        "Shortcodes": "Shortcodes",
        "Sitemap nie wskazuje formularza dla tej schemy.": "Die Sitemap verweist auf kein Formular für dieses Schema.",
        "Sitemapy": "Sitemaps",
        "Skopiowano": "Kopiert",
        "Skopiowano dev details": "Entwicklerdetails kopiert",
        "Skopiowano JSON szablonu do schowka.": "Das JSON der Vorlage wurde in die Zwischenablage kopiert.",
        "Skopiowano link do widgetu": "Der Widget-Link wurde kopiert",
        "Skopiowano pakiet debugowy": "Debug-Paket kopiert",
        "Skrócony opis": "Kurzbeschreibung",
        "Skróty klawiszowe": "Tastenkombinationen",
        "Skrypty statystyczne, np. Analytics lub Matomo. Są dodawane w górnej części <head> witryny.": "Statistik-Skripte, z. B. Analytics oder Matomo. Sie werden im oberen Bereich des <head> der Website hinzugefügt.",
        "Skrypty targetujące, np. Google Tag Manager lub Pixel Facebook. Są dodawane w górnej części <body> witryny.": "Targeting-Skripte, z. B. Google Tag Manager oder Facebook Pixel. Sie werden im oberen Bereich des <body> der Website hinzugefügt.",
        "Skrypty zewnętrzne": "Externe Skripte",
        "Skup na tym bloku": "Auf diesen Block fokussieren",
        "Skupiono widget": "Widget fokussiert",
        "Slajd {number}": "Folie {number}",
        "Slajder został dodany.": "Der Slider wurde hinzugefügt.",
        "Slajder został usunięty.": "Der Slider wurde gelöscht.",
        "Slajder został zaktualizowany.": "Der Slider wurde aktualisiert.",
        "Slajdery": "Slider",
        "słów": "Wörter",
        "Słowa kluczowe": "Schlüsselwörter",
        "Słowa kluczowe opisujące artykuł": "Schlüsselwörter zur Beschreibung des Artikels",
        "Słowa oddzielone przecinkami.": "Durch Kommas getrennte Wörter.",
        "Słowo": "Wort",
        "Słowo lub wyrażenie zamieniane na link.": "Wort oder Ausdruck, der durch einen Link ersetzt wird.",
        "slug lub tytuł": "Slug oder Titel",
        "slug strony z listą": "Slug der Listenseite",
        "slug tytułu": "Titel-Slug",
        "slugifikowany pełny tytuł treści w języku sitemapy": "Slug des vollständigen Inhaltstitels in der Sitemap-Sprache",
        "slugifikowany tytuł": "Slug des Titels",
        "Sobota": "Samstag",
        "Sortowanie": "Sortierung",
        "Sortowanie autorów": "Sortierung der Autoren",
        "Sortowanie kategorii": "Sortierung der Kategorien",
        "Sortowanie pakietów": "Sortierung der Pakete",
        "Sortuj autorów": "Autoren sortieren",
        "Sortuj kategorie": "Kategorien sortieren",
        "Sortuj pakiety": "Pakete sortieren",
        "Sortuj według": "Sortieren nach",
        "Specjalne role w serwisie": "Spezielle Rollen im Dienst",
        "Sposób ładowania obrazów w tej sekcji": "Art des Ladens von Bildern in diesem Abschnitt",
        "Sposób ładowania obrazów w tej sekcji (dziedziczony przez aranżacje)": "Art des Ladens von Bildern in diesem Abschnitt (wird von Layouts übernommen)",
        "Sposób publikacji nowych komentarzy.": "Art der Veröffentlichung neuer Kommentare.",
        "Sprawdź gramatykę": "Grammatik prüfen",
        "Sprawdź nazwę kategorii.": "Kategorienamen prüfen.",
        "Sprawdź połączenie i spróbuj ponownie.": "Verbindung prüfen und erneut versuchen.",
        "Sprawdź poprawność faktów i nazw własnych": "Fakten und Eigennamen auf Richtigkeit prüfen",
        "Sprawdź, czy w treści nie ma powtórzeń": "Prüfen, ob der Inhalt Wiederholungen enthält",
        "Spróbuj pobrać listę ponownie.": "Versuchen Sie, die Liste erneut abzurufen.",
        "Spróbuj ponownie": "Erneut versuchen",
        "Środa": "Mittwoch",
        "Środowisko": "Umgebung",
        "stały identyfikator": "Stabile ID",
        "Stara cena brutto": "Alter Bruttopreis",
        "Status": "Status",
        "Status aranżacji został zmieniony.": "Der Status des Layouts wurde geändert.",
        "Status artykułu": "Artikelstatus",
        "Status baneru został zmieniony.": "Der Bannerstatus wurde geändert.",
        "Status dokumentu został zmieniony.": "Der Dokumentstatus wurde geändert.",
        "Status galerii został zmieniony.": "Der Galeriestatus wurde geändert.",
        "Status komentarzy": "Kommentarstatus",
        "Status linku został zmieniony.": "Der Linkstatus wurde geändert.",
        "Status przekierowania został zmieniony.": "Der Weiterleitungsstatus wurde geändert.",
        "Status regulaminu został zmieniony.": "Der Status der Nutzungsbedingungen wurde geändert.",
        "Status wideo został zmieniony.": "Der Videostatus wurde geändert.",
        "Status zamówienia": "Bestellstatus",
        "Statyczny": "Statisch",
        "Streść fragment w dwóch zdaniach": "Fassen Sie den Abschnitt in zwei Sätzen zusammen",
        "Streść fragment w pięciu punktach": "Fassen Sie den Abschnitt in fünf Stichpunkten zusammen",
        "Streść treść w pięciu punktach": "Fassen Sie den Inhalt in fünf Stichpunkten zusammen",
        "Streszczenie": "Zusammenfassung",
        "Strona": "Seite",
        "Strona błędu 404": "404-Fehlerseite",
        "Strona CMS": "CMS-Seite",
        "Strona do publikacji": "Zu veröffentlichende Seite",
        "Strona docelowa dla 'Czytaj więcej'": "Zielseite für „Mehr lesen“",
        "Strona docelowa dla 'Kontakt z adminem'": "Zielseite für „Administrator kontaktieren“",
        "Strona docelowa dla 'Pliki cookies'": "Zielseite für „Cookies“",
        "Strona docelowa dla 'Polityka prywatności'": "Zielseite für „Datenschutzerklärung“",
        "Strona dostępna dla wszystkich": "Für alle zugängliche Seite",
        "Strona dostępna tylko dla zalogowanych użytkowników": "Nur für angemeldete Benutzer zugängliche Seite",
        "Strona głowna": "Startseite",
        "Strona główna": "Startseite",
        "Strona główna serwisu": "Startseite der Website",
        "Strona kanoniczna": "Kanonische Seite",
        "Strona konta użytkownika powiązana z powiadomieniami.": "Benutzerkontoseite, die mit Benachrichtigungen verknüpft ist.",
        "Strona korzystająca tylko z aranżacji": "Seite, die nur das Layout verwendet",
        "Strona korzystająca z modułu": "Seite, die ein Modul verwendet",
        "Strona logowania użytkowników": "Anmeldeseite für Benutzer",
        "Strona nadrzędna": "Übergeordnete Seite",
        "Strona obsługująca logowanie i konto użytkownika.": "Seite für Anmeldung und Benutzerkonto.",
        "Strona opublikowana": "Veröffentlichte Seite",
        "Strona ukryta w menu": "Im Menü ausgeblendete Seite",
        "Strona utworzona w PageBuilderze": "Mit dem PageBuilder erstellte Seite",
        "Strona z modułu konto użytkownika": "Seite aus dem Benutzerkontomodul",
        "Strona z modułu wyszukiwarki": "Seite aus dem Suchmodul",
        "Strona została dodana.": "Die Seite wurde hinzugefügt.",
        "Strona została usunięta.": "Die Seite wurde gelöscht.",
        "Strona została zaktualizowana.": "Die Seite wurde aktualisiert.",
        "Strona, na której użytkownik znajdzie kontakt do administratora.": "Seite, auf der Benutzer die Kontaktdaten des Administrators finden.",
        "Strona, na której wyświetlane są wyniki wyszukiwania.": "Seite, auf der Suchergebnisse angezeigt werden.",
        "Strona/kategoria nadrzędna": "Übergeordnete Seite/Kategorie",
        "Strony": "Seiten",
        "Strony gazetki": "Seiten des Prospekts",
        "Strony publikacji": "Veröffentlichungsseiten",
        "Strony z treścią": "Inhaltsseiten",
        "Struktura menu": "Menüstruktur",
        "Struktura serwisu": "Website-Struktur",
        "Struktura stron": "Seitenstruktur",
        "Studio": "Studio",
        "Studio obsługuje również pola formularza. Klucz szablonu ma postać „symbolModułu/symbolSekcji”.": "Studio unterstützt auch Formularfelder. Der Vorlagenschlüssel hat das Format „Modulsymbol/Abschnittssymbol“.",
        "Styl tekstu": "Textstil",
        "Styl Tekstu": "Textstil",
        "Subskrypcja": "Abonnement",
        "Subskrypcja aktywna": "Abonnement aktiv",
        "Subskrypcje": "Abonnements",
        "Subskrypcje klienta": "Kundenabonnements",
        "Suma": "Summe",
        "Suma proporcji musi wynosić 100%. Pozostałe kolumny przejdą do kolejnego wiersza.": "Die Summe der Anteile muss 100 % betragen. Die übrigen Spalten werden in die nächste Zeile verschoben.",
        "Sygnatura widoczna na listingu.": "In der Listenansicht angezeigte Signatur.",
        "Symbol": "Symbol",
        "Symbol autora": "Autorensymbol",
        "Symbol linku": "Linksymbol",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku -": "Das Symbol darf nur Kleinbuchstaben, Ziffern und das Zeichen - enthalten",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku - ": "Das Symbol darf nur Kleinbuchstaben, Ziffern und das Zeichen - enthalten ",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku -.": "Das Symbol darf nur Kleinbuchstaben, Ziffern und das Zeichen - enthalten.",
        "Symbol strony": "Seitensymbol",
        "Symboliczne miejsce na treść modułu strony korzystającej z tego typu aranżacji.": "Symbolischer Platzhalter für den Inhalt des Moduls einer Seite, die dieses Layout verwendet.",
        "Synchronizuj": "Synchronisieren",
        "System": "System",
        "System operacyjny": "Betriebssystem",
        "Szablon nie określa miejsca treści modułu.": "Die Vorlage legt keinen Platz für den Modulinhalt fest.",
        "Szablon określa sekcje, w których możesz umieszczać widgety. Wybierz układ odpowiedni dla tej strony.": "Die Vorlage definiert Abschnitte, in denen Sie Widgets platzieren können. Wählen Sie ein passendes Layout für diese Seite aus.",
        "Szablon określa układ wiadomości. W wysyłce używana jest jego opublikowana wersja.": "Die Vorlage legt das Layout der Nachricht fest. Beim Versand wird die veröffentlichte Version verwendet.",
        "Szablon wiadomości": "Nachrichtenvorlage",
        "Szablon został dodany.": "Die Vorlage wurde hinzugefügt.",
        "Szablon został usunięty.": "Die Vorlage wurde gelöscht.",
        "Szablon został zaktualizowany.": "Die Vorlage wurde aktualisiert.",
        "Szablony": "Vorlagen",
        "Szablony adresów URL wpisów w formacie JSON.": "Vorlagen für Beitrags-URLs im JSON-Format.",
        "Szablony URL": "URL-Vorlagen",
        "Szablony URL (JSON)": "URL-Vorlagen (JSON)",
        "Szczegóły": "Details",
        "Szczegóły klienta": "Kundendetails",
        "Szczegóły regulaminu": "Details der Nutzungsbedingungen",
        "Szczegóły techniczne": "Technische Details",
        "Szczegóły wpisu": "Beitragsdetails",
        "Szczegóły zamówienia": "Bestelldetails",
        "Szerokość": "Breite",
        "Szerokość podglądu": "Vorschau-Breite",
        "Szerokość podglądu: {width} px": "Vorschau-Breite: {width} px",
        "Szukaj aranżacji": "Layouts suchen",
        "Szukaj aranżacji…": "Layouts suchen…",
        "Szukaj sekcji": "Abschnitte suchen",
        "Szukaj sekcji…": "Abschnitt suchen…",
        "Szukaj strony": "Seite suchen",
        "Szukaj widżetu": "Widget suchen",
        "Szukaj widżetu…": "Widget suchen…",
        "Ta aranżacja zostanie użyta, jeśli nie przypisano żadnej innej aranżacji do strony.": "Dieses Layout wird verwendet, wenn der Seite kein anderes Layout zugewiesen wurde.",
        "Ta treść jest współdzielona przez wszystkie użycia tego widgetu.": "Dieser Inhalt wird von allen Verwendungen dieses Widgets gemeinsam genutzt.",
        "Tablet": "Tablet",
        "Tagi": "Tags",
        "Tagi nie są widoczne w przypadku zaznaczenia opcji \"Tylko treść artykułu\".": "Tags sind nicht sichtbar, wenn die Option „Nur Artikelinhalt“ ausgewählt ist.",
        "Tak": "Ja",
        "Target": "Ziel",
        "Te funkcje korzystają z Googlebota. Powyższe ustawienia nie oddzielają ich od zwykłego indeksowania Google Search.": "Diese Funktionen verwenden den Googlebot. Die obigen Einstellungen trennen sie nicht von der normalen Google-Suche-Indexierung.",
        "Te ustawienia służą do przygotowania wyglądu wiadomości wysyłanych w ramach automatyzacji tej witryny. Wybierz domyślne logo i szablon oraz przygotuj stopkę dla poszczególnych języków, aby e-maile miały spójny wygląd.": "Mit diesen Einstellungen legen Sie das Erscheinungsbild von Nachrichten fest, die im Rahmen der Automatisierung dieser Website versendet werden. Wählen Sie ein Standardlogo und eine Vorlage aus und erstellen Sie für jede Sprache eine Fußzeile, damit die E-Mails ein einheitliches Erscheinungsbild haben.",
        "Tekst": "Text",
        "Tekst formatowany": "Formatierter Text",
        "Tekst prezentowany przy formularzu zapisu do newslettera.": "Text, der neben dem Newsletter-Anmeldeformular angezeigt wird.",
        "Tekst wyświetlany nad galerią": "Text, der über der Galerie angezeigt wird",
        "Tekst wyświetlany nad gazetką": "Text, der über dem Magazin angezeigt wird",
        "Tekstowy / HTML / JS": "Text / HTML / JS",
        "Telefon": "Telefon",
        "Ten komentarz nie ma zgłoszeń do moderacji.": "Für diesen Kommentar liegen keine Moderationsmeldungen vor.",
        "Ten komponent nie ma dodatkowych opcji do skonfigurowania.": "Für diese Komponente gibt es keine zusätzlichen konfigurierbaren Optionen.",
        "Ten widget nie jest dostępny w żadnej sekcji tej aranżacji.": "Dieses Widget ist in keinem Abschnitt dieses Layouts verfügbar.",
        "Ten widget nie może zostać przeniesiony do wskazanej sekcji.": "Dieses Widget kann nicht in den angegebenen Abschnitt verschoben werden.",
        "Ten widżet nie ma dodatkowej konfiguracji": "Für dieses Widget gibt es keine zusätzliche Konfiguration.",
        "Ten wpis jest już wykorzystywany w treści, dlatego jego ustawienia są zablokowane. Możesz sprawdzić obecną konfigurację. Jeśli potrzebujesz innych ustawień, wróć do listy i dodaj nowy link wewnętrzny.": "Dieser Eintrag wird bereits in einem Inhalt verwendet. Daher sind seine Einstellungen gesperrt. Sie können die aktuelle Konfiguration anzeigen. Wenn Sie andere Einstellungen benötigen, kehren Sie zur Liste zurück und fügen Sie einen neuen internen Link hinzu.",
        "Ten wpis jest użyty w aranżacjach:": "Dieser Eintrag wird in folgenden Layouts verwendet:",
        "Termin publikacji": "Veröffentlichungstermin",
        "Testowe": "Test",
        "Testowe służy do sprawdzania integracji, a Produkcyjne do rzeczywistych płatności. Wprowadź dane punktu POS zgodne z wybranym środowiskiem.": "Die Testumgebung dient zum Überprüfen der Integration, die Produktionsumgebung für echte Zahlungen. Geben Sie die POS-Daten entsprechend der ausgewählten Umgebung ein.",
        "Tłumaczenie": "Übersetzung",
        "Tokeny": "Token",
        "Tonalność tekstu": "Tonalität des Textes",
        "Tonalność Tekstu": "Tonalität des Textes",
        "Top temat został dodany.": "Das Top-Thema wurde hinzugefügt.",
        "Top temat został usunięty.": "Das Top-Thema wurde gelöscht.",
        "Top temat został zaktualizowany.": "Das Top-Thema wurde aktualisiert.",
        "Top tematy": "Top-Themen",
        "Transfer": "Übertragung",
        "Transfer sekcji": "Abschnitt übertragen",
        "Transfer strony": "Seite übertragen",
        "Treść": "Inhalt",
        "Treść aktualności": "Nachrichteninhalt",
        "Treść bez nazwy": "Inhalt ohne Namen",
        "Treść generowana przez AI – sprawdź ją przed wstawieniem.": "Von der KI generierter Inhalt – bitte vor dem Einfügen überprüfen.",
        "Treść i kolejność slajdów są zarządzane w wybranym rotatorze.": "Inhalt und Reihenfolge der Folien werden im ausgewählten Rotator verwaltet.",
        "Treść komentarza": "Kommentarinhalt",
        "Treść komunikatu wyświetlana na stronie.": "Inhalt der auf der Seite angezeigten Mitteilung.",
        "Treść linku": "Linktext",
        "Treść modułu": "Modulinhalt",
        "Treść na końcu wiadomości, np. dane kontaktowe firmy. Przygotuj ją osobno dla każdego języka. Puste pole korzysta z domyślnej stopki systemu.": "Inhalt am Ende der Nachricht, z. B. die Kontaktdaten des Unternehmens. Erstellen Sie ihn separat für jede Sprache. Bei einem leeren Feld wird die standardmäßige Systemfußzeile verwendet.",
        "Treść nie może być pusta.": "Der Inhalt darf nicht leer sein.",
        "Treść odpowiedzi": "Antwortinhalt",
        "Treść opinii wyświetlana na stronie": "Inhalt der auf der Seite angezeigten Bewertung",
        "Treść powstaje z sekcji i widgetów aranżacji. Strona nie korzysta z modułu.": "Der Inhalt setzt sich aus den Abschnitten und Widgets des Layouts zusammen. Die Seite verwendet kein Modul.",
        "Treść premium": "Premium-Inhalt",
        "Treść pytania widoczna dla użytkowników": "Fragetext, der für Benutzer sichtbar ist",
        "Treści": "Inhalte",
        "Treści uwzględniane w wynikach wyszukiwania witryny.": "Inhalte, die in den Suchergebnissen der Website berücksichtigt werden.",
        "Treści w tym widżecie": "Inhalte in diesem Widget",
        "Treści widgetu zostały zapisane.": "Die Widget-Inhalte wurden gespeichert.",
        "Tryb „Z metadanych / generatora” zachowuje wartości ustawione dla stron CMS. Wpisy Studio korzystają z wartości weekly i 0.5. Własna wartość zastępuje je we wszystkich sitemapach. Po zapisaniu ustawień wygeneruj sitemapy ponownie.": "Der Modus „Aus Metadaten / Generator“ übernimmt die für CMS-Seiten festgelegten Werte. Studio-Einträge verwenden die Werte weekly und 0.5. Ein eigener Wert ersetzt diese in allen Sitemaps. Generieren Sie die Sitemaps nach dem Speichern der Einstellungen erneut.",
        "Tryb galerii": "Galerie-Modus",
        "Tryb oraz struktura sekcji wynikają z wybranego szablonu.": "Modus und Struktur des Abschnitts richten sich nach der ausgewählten Vorlage.",
        "Tryb pracy": "Betriebsmodus",
        "Tryb układu": "Layoutmodus",
        "Tryb wyświetlania": "Anzeigemodus",
        "Tydzień": "Woche",
        "Tylko 404": "Nur 404",
        "Tylko aktywne": "Nur aktive",
        "Tylko data – 2026-09-04": "Nur Datum – 2026-09-04",
        "Tylko gdy odpowiedź serwera jest 404": "Nur wenn die Serverantwort 404 lautet",
        "Tylko małe litery, bez znaków specjalnych, cyfr i spacji.": "Nur Kleinbuchstaben, keine Sonderzeichen, Ziffern oder Leerzeichen.",
        "Tylko priorytetowe": "Nur priorisierte",
        "Tylko treść": "Nur Inhalt",
        "Tylko treść artykułu": "Nur Artikelinhalt",
        "Tylko zalogowani użytkownicy mogą polubić komentarz.": "Nur angemeldete Benutzer können einen Kommentar mit „Gefällt mir“ markieren.",
        "Typ": "Typ",
        "Typ aranżacji": "Layouttyp",
        "Typ autora": "Autorentyp",
        "Typ bannera": "Bannertyp",
        "Typ długości": "Längentyp",
        "Typ linku": "Linktyp",
        "Typ obiektu": "Objekttyp",
        "Typ pakietu": "Pakettyp",
        "Typ rankingu": "Rankingtyp",
        "Typ strony": "Seitentyp",
        "Typ zestawu": "Settyp",
        "Typy aranżacji": "Layouttypen",
        "Tytuł": "Titel",
        "Tytuł aktywnej witryny": "Titel der aktiven Website",
        "Tytuł dokumentu": "Dokumenttitel",
        "Tytuł elementu": "Elementtitel",
        "Tytuł i tagi filmu": "Filmtitel und Tags",
        "Tytuł i tagi galerii": "Galerietitel und Tags",
        "Tytuł okładki": "Titel des Titelbilds",
        "Tytuł pomocniczy": "Untertitel",
        "Tytuł pomocniczy jest wyświetlany przed tytułem artykułu.": "Der Untertitel wird vor dem Artikeltitel angezeigt.",
        "Tytuł przerwy technicznej": "Titel der Wartungsseite",
        "Tytuł strony": "Seitentitel",
        "Tytuł witryny": "Seitentitel",
        "Tytuł wyświetlany na liście filmów i przy materiale wideo.": "Titel, der in der Filmliste und beim Video angezeigt wird.",
        "Tytuł wyświetlany na liście galerii i nad jej zawartością.": "Titel, der in der Galerieliste und über ihrem Inhalt angezeigt wird.",
        "Tytuł, opis i indeksowanie.": "Titel, Beschreibung und Indexierung.",
        "Uczenie modeli i uzupełnianie odpowiedzi": "Modelltraining und Ergänzung von Antworten",
        "Udostępnia plik publicznie po zapisaniu witryny. Publikacja jest niezależna od ustawień robotów AI.": "Stellt die Datei nach dem Speichern der Website öffentlich bereit. Die Veröffentlichung ist unabhängig von den Einstellungen für KI-Robots.",
        "Udostępnia ten artykuł premium bez ograniczania dostępu.": "Stellt diesen Premium-Artikel ohne Zugriffsbeschränkung bereit.",
        "Udostępnia witrynę odwiedzającym.": "Stellt die Website Besuchern zur Verfügung.",
        "Ujednolić terminologię z resztą artykułu": "Terminologie an den Rest des Artikels angleichen",
        "Układ dynamiczny": "Dynamisches Layout",
        "Układ statyczny": "Statisches Layout",
        "Układ treści oraz moduł obsługujący stronę.": "Inhaltslayout und Modul, das die Seite verwaltet.",
        "Ukryj": "Ausblenden",
        "Ukryj blok": "Block ausblenden",
        "Ukryj nazwę w aplikacji": "Namen in der App ausblenden",
        "Ukryte widgety": "Ausgeblendete Widgets",
        "Ukrywa komentarze przed gośćmi. Wymaga też logowania do dodawania komentarzy i polubień.": "Blendet Kommentare für Gäste aus. Erfordert außerdem eine Anmeldung, um Kommentare hinzuzufügen und Beiträge zu liken.",
        "Ukrywa możliwość komentowania tego artykułu.": "Blendet die Kommentarfunktion für diesen Artikel aus.",
        "Ukrywa nagłówek widżetu na stronie. Jego zawartość pozostaje widoczna, a nazwa w panelu nie zmienia się.": "Blendet die Widget-Überschrift auf der Seite aus. Der Inhalt bleibt sichtbar und der Name im Bedienfeld unverändert.",
        "Ukrywa pozycję w menu bez wyłączania dostępu do strony.": "Blendet den Menüpunkt aus, ohne den Zugriff auf die Seite zu deaktivieren.",
        "Ukrywa przyciski udostępniania artykułu.": "Blendet die Schaltflächen zum Teilen des Artikels aus.",
        "Umiejscowienie": "Platzierung",
        "Uprawnienia": "Berechtigungen",
        "Upuść widżet w sekcji {name}": "Ziehen Sie das Widget in den Bereich {name}",
        "URL": "URL",
        "Urządzenie dla kolejności sekcji": "Gerät für die Reihenfolge der Bereiche",
        "Usatwienia komentarzy": "Kommentareinstellungen",
        "Ustaw kategorię": "Kategorie festlegen",
        "Ustaw nazwę, sposób budowania i rozmieszczenie sekcji.": "Legen Sie den Namen, die Erstellungsweise und die Anordnung der Bereiche fest.",
        "Ustaw również dla wszystkich podstron": "Auch für alle Unterseiten festlegen",
        "Ustawienia": "Einstellungen",
        "Ustawienia aranżacji": "Layout-Einstellungen",
        "Ustawienia baneru": "Banner-Einstellungen",
        "Ustawienia dostępności": "Barrierefreiheitseinstellungen",
        "Ustawienia i wersje regulaminu": "Einstellungen und Versionen der Nutzungsbedingungen",
        "Ustawienia komentarzy": "Kommentareinstellungen",
        "Ustawienia modułu": "Moduleinstellungen",
        "Ustawienia pakietu": "Paket-Einstellungen",
        "Ustawienia płatności": "Zahlungseinstellungen",
        "Ustawienia podstawowe": "Grundeinstellungen",
        "Ustawienia redakcji": "Redaktionseinstellungen",
        "Ustawienia RSS": "RSS-Einstellungen",
        "Ustawienia sekcji": "Bereichseinstellungen",
        "Ustawienia sitemap": "Sitemap-Einstellungen",
        "Ustawienia slajdera": "Slider-Einstellungen",
        "Ustawienia strony": "Seiteneinstellungen",
        "Ustawienia widgetu": "Widget-Einstellungen",
        "Ustawienia widżetu": "Widget-Einstellungen",
        "Ustawienia witryny": "Website-Einstellungen",
        "Ustawienia z definicji szablonu.": "Einstellungen aus der Vorlagendefinition.",
        "Ustawienia zostały zaktualizowane.": "Die Einstellungen wurden aktualisiert.",
        "Ustawienia zostały zapisane.": "Die Einstellungen wurden gespeichert.",
        "Usuń": "Löschen",
        "Usuń artykuł z listy": "Artikel aus der Liste entfernen",
        "Usuń autora": "Autor entfernen",
        "Usuń autora z widżetu": "Autor aus dem Widget entfernen",
        "Usuń blok": "Block entfernen",
        "Usuń dokument": "Dokument entfernen",
        "Usuń element": "Element entfernen",
        "Usuń katalog": "Verzeichnis entfernen",
        "Usuń kategorię": "Kategorie entfernen",
        "Usuń odpowiedź": "Antwort entfernen",
        "Usuń opinię": "Bewertung entfernen",
        "Usuń plik": "Datei entfernen",
        "Usuń powiązanie": "Verknüpfung entfernen",
        "Usuń powód": "Grund entfernen",
        "Usuń powtórzenia i skróć bez utraty sensu": "Wiederholungen entfernen und kürzen, ohne den Sinn zu verändern",
        "Usuń publikację": "Veröffentlichung entfernen",
        "Usuń pytanie": "Frage entfernen",
        "Usuń regulamin {name}": "Nutzungsbedingungen {name} entfernen",
        "Usuń sekcję": "Bereich entfernen",
        "Usuń slajd {number}": "Folie {number} entfernen",
        "Usuń słowo": "Wort entfernen",
        "Usuń stronę": "Seite entfernen",
        "Usuń typ": "Typ entfernen",
        "Usuń widget z sekcji": "Widget aus dem Bereich entfernen",
        "Usuń wybrany element": "Ausgewähltes Element entfernen",
        "Usuń zestaw {name}": "Set {name} entfernen",
        "Usunąć autora z tego widżetu?": "Autor aus diesem Widget entfernen?",
        "Usunąć sekcję wraz z umieszczonymi w niej widgetami?": "Bereich einschließlich der darin platzierten Widgets entfernen?",
        "Usunąć sekcję?": "Bereich entfernen?",
        "Usunąć sekcję? Jej kolumny przestaną być slotami na widgety w aranżacjach.": "Bereich entfernen? Seine Spalten sind dann in Layouts keine Widget-Slots mehr.",
        "Usunąć tę sekcję wraz z treścią?": "Diesen Bereich einschließlich des Inhalts entfernen?",
        "Usunąć widżet z tej sekcji?": "Widget aus diesem Bereich entfernen?",
        "Usunąć własny typ aranżacji? Istniejące aranżacje korzystające z tego typu przestaną mieć poprawny szablon.": "Eigenen Layouttyp entfernen? Vorhandene Layouts, die diesen Typ verwenden, haben dann keine gültige Vorlage mehr.",
        "Usunięcie tej strony spowoduje również usunięcie stron podrzędnych.": "Wenn Sie diese Seite löschen, werden auch die untergeordneten Seiten gelöscht.",
        "Usuniesz {count} końcowych kolumn. Przenieś wcześniej ich widżety w aranżacjach korzystających z tego szablonu.": "Sie entfernen die letzten {count} Spalten. Verschieben Sie zuvor deren Widgets in Layouts, die diese Vorlage verwenden.",
        "usunięto": "gelöscht",
        "Usunięto widget": "Widget entfernt",
        "Utwórz nową": "Neu erstellen",
        "Uzupełnij automatyczne reguły witryny o własne instrukcje dla robotów.": "Ergänzen Sie die automatischen Website-Regeln um eigene Anweisungen für Robots.",
        "Uzupełnij fragment o kontekst dla czytelnika": "Ergänzen Sie den Auszug um Kontext für den Leser",
        "Uzupełnij konfigurację po lewej, aby wybrać szablon i rozmieścić widgety.": "Vervollständigen Sie die Konfiguration links, um eine Vorlage auszuwählen und Widgets anzuordnen.",
        "Uzupełnij poprawny adres domenowy w Ustawieniach, aby otworzyć podgląd.": "Geben Sie in den Einstellungen eine gültige Domainadresse ein, um die Vorschau zu öffnen.",
        "Użyta na stronach": "Auf Seiten verwendet",
        "Użytkownicy mogą zgłaszać komentarze": "Benutzer können Kommentare melden",
        "Użytkownicy z bazy": "Benutzer aus der Datenbank",
        "Użytkownik dokonał rejestracji samodzielnie.": "Der Benutzer hat sich selbst registriert.",
        "Użytkownik musi potwierdzić adres e-mail.": "Der Benutzer muss die E-Mail-Adresse bestätigen.",
        "Użytkownik z bazy": "Benutzer aus der Datenbank",
        "użytkowników online": "Online-Benutzer",
        "Użyty w {count} innych aranżacjach": "Verwendet in {count} weiteren Layouts",
        "Używane jako główna ilustracja artykułu.": "Wird als Hauptbild des Artikels verwendet.",
        "W aplikacji frontendowej uruchom asystenta komend `npm run edito`, a następnie wklej poniżej zawartość pliku `theme.json` właściwego dla tego szablonu.": "Starten Sie in der Frontend-Anwendung den Befehlsassistenten mit `npm run edito` und fügen Sie anschließend unten den Inhalt der für diese Vorlage vorgesehenen Datei `theme.json` ein.",
        "W drodze": "Unterwegs",
        "W przypadku braku wartości zostanie wyświetlona nazwa strony.": "Wenn kein Wert angegeben ist, wird der Seitenname angezeigt.",
        "W przypadku zaznaczenia opcji \"Artykuł sponsorowany\" lub \"Opinia\", etykieta jest ustawiona automatycznie.": "Wenn die Option „Gesponserter Artikel“ oder „Meinung“ ausgewählt ist, wird das Label automatisch festgelegt.",
        "W trakcie przygotowania": "In Vorbereitung",
        "W tym katalogu nie ma jeszcze żadnych stron.": "In diesem Verzeichnis gibt es noch keine Seiten.",
        "W tym miejscu pojawi się treść modułu przypisanego do strony.": "Hier wird der Inhalt des der Seite zugewiesenen Moduls angezeigt.",
        "W widoku opublikowanej wersji edycja jest wyłączona.": "In der Ansicht der veröffentlichten Version ist die Bearbeitung deaktiviert.",
        "W wybranych aranżacjach dotychczasowa zawartość tej sekcji zostanie zastąpiona.": "In den ausgewählten Layouts wird der bisherige Inhalt dieses Abschnitts ersetzt.",
        "Walidacja": "Validierung",
        "Wartość": "Wert",
        "Wartość długości": "Längenwert",
        "Wartość jest za długa.": "Der Wert ist zu lang.",
        "Wartość może być za długa.": "Der Wert ist möglicherweise zu lang.",
        "Wartość tekstowa": "Textwert",
        "Wczytaj więcej": "Mehr laden",
        "Wczytywanie": "Wird geladen",
        "Wczytywanie formularza…": "Formular wird geladen…",
        "Wczytywanie stron": "Seiten werden geladen",
        "Wczytywanie ustawień strony…": "Seiteneinstellungen werden geladen…",
        "Wczytywanie zgód": "Einwilligungen werden geladen",
        "Wczytywanie...": "Wird geladen...",
        "Wersja": "Version",
        "Wersja językowa": "Sprachversion",
        "Wersja językowa treści i widgetów używanych w tej aranżacji.": "Sprachversion der Inhalte und Widgets, die in diesem Layout verwendet werden.",
        "Wersja podglądu": "Vorschauversion",
        "Wersja robocza została przywrócona.": "Der Entwurf wurde wiederhergestellt.",
        "Wersje": "Versionen",
        "Wersje językowe": "Sprachversionen",
        "Weryfikacja reCAPTCHA podczas wysyłania formularza.": "reCAPTCHA-Überprüfung beim Absenden des Formulars.",
        "Wewnętrzny": "Intern",
        "Wiadomość została wysłana.": "Die Nachricht wurde gesendet.",
        "Wideo": "Video",
        "Wideo nie jest jeszcze nigdzie opublikowane.": "Das Video wurde noch nirgendwo veröffentlicht.",
        "Wideo nie ma ustawionej daty publikacji.": "Für das Video ist kein Veröffentlichungsdatum festgelegt.",
        "Wideo premium": "Premiumvideo",
        "Wideo zostało dodane.": "Das Video wurde hinzugefügt.",
        "Wideo zostało usunięte.": "Das Video wurde gelöscht.",
        "Wideo zostało zaktualizowane.": "Das Video wurde aktualisiert.",
        "Widget dynamiczny nie ma kompletnych ustawień modułu.": "Das dynamische Widget hat keine vollständigen Moduleinstellungen.",
        "Widget ID": "Widget-ID",
        "Widget jest wyłączony dla tej witryny": "Das Widget ist für diese Website deaktiviert",
        "Widget służy do wczytania ustawień wiadomości email według wybranej witryny i wersji językowej.": "Das Widget dient dazu, die E-Mail-Einstellungen entsprechend der ausgewählten Website und Sprachversion zu laden.",
        "Widget Studio": "Widget Studio",
        "Widget unikalny może zostać użyty tylko raz": "Ein eindeutiges Widget kann nur einmal verwendet werden",
        "Widget został dodany do aranżacji.": "Das Widget wurde zum Layout hinzugefügt.",
        "Widget został skopiowany do wskazanej witryny.": "Das Widget wurde auf die angegebene Website kopiert.",
        "Widget został usunięty.": "Das Widget wurde gelöscht.",
        "Widget został zduplikowany.": "Das Widget wurde dupliziert.",
        "Widget źródłowy": "Quell-Widget",
        "Widoczna tylko dla redaktorów.": "Nur für Redakteure sichtbar.",
        "Widoczna w menu witryny i w drzewie stron.": "Im Website-Menü und im Seitenbaum sichtbar.",
        "Widoczna wyłącznie w panelu.": "Nur im Dashboard sichtbar.",
        "widoczne": "sichtbar",
        "Widoczne typy widgetów: %0": "Sichtbare Widget-Typen: %0",
        "Widoczność": "Sichtbarkeit",
        "Widoczność w wyszukiwarkach AI": "Sichtbarkeit in KI-Suchmaschinen",
        "Widoczność zdjęcia": "Sichtbarkeit des Bildes",
        "Widok": "Ansicht",
        "Widok czołówki - zdjęcie z tytułem": "Titelbildansicht – Bild mit Titel",
        "Widok narzędzi": "Werkzeugansicht",
        "Widżety": "Widgets",
        "Widżety szablonu": "Vorlagen-Widgets",
        "Więcej": "Mehr",
        "Witryna": "Website",
        "Witryna / Wersja językowa": "Website / Sprachversion",
        "Witryna aktywna": "Aktive Website",
        "Witryna docelowa": "Zielwebsite",
        "Witryna domyślna": "Standardwebsite",
        "Witryna i język": "Website und Sprache",
        "Witryna internetowa": "Website",
        "Witryna określa dostępne szablony, języki i widgety.": "Die Website legt fest, welche Vorlagen, Sprachen und Widgets verfügbar sind.",
        "Witryna tylko dla zalogowanych użytkowników": "Website nur für angemeldete Benutzer",
        "Witryna została usunięta.": "Die Website wurde gelöscht.",
        "Witryna została zapisana.": "Die Website wurde gespeichert.",
        "Witryny": "Websites",
        "Wklej wartość Drugi klucz (MD5) z konfiguracji tego samego punktu płatności w PayU.": "Fügen Sie den Wert des zweiten Schlüssels (MD5) aus der Konfiguration desselben Zahlungspunkts in PayU ein.",
        "Wklej zawartość pliku JSON z kluczem konta usługi Google Cloud używanego do odczytu statystyk.": "Fügen Sie den Inhalt der JSON-Datei mit dem Dienstkontoschlüssel von Google Cloud ein, der zum Abrufen der Statistiken verwendet wird.",
        "Włącz ankietę": "Umfrage aktivieren",
        "Włącz cache": "Cache aktivieren",
        "Włącz formularz kontaktowy": "Kontaktformular aktivieren",
        "Włącz przynajmniej jedną wersję językową dla witryny aby rozpocząć zarządzanie stronami.": "Aktivieren Sie mindestens eine Sprachversion für die Website, um mit der Seitenverwaltung zu beginnen.",
        "Włącz publikację pliku llms.txt poniżej.": "Aktivieren Sie unten die Veröffentlichung der Datei llms.txt.",
        "Włącz social media": "Soziale Medien aktivieren",
        "Włącz wszystkie": "Alle aktivieren",
        "Włącz, aby prezentować zdjęcie wraz z tytułem czołówki.": "Aktivieren, um das Titelbild zusammen mit dem Titel anzuzeigen.",
        "Włącza komentarze dla wybranej witryny i wersji językowej. Pozostałe ustawienia określają dostęp i moderację.": "Aktiviert Kommentare für die ausgewählte Website und Sprachversion. Die übrigen Einstellungen legen Zugriff und Moderation fest.",
        "Włączenie generowania pliku sitemap.xml dla całej witryny": "Aktiviert die Generierung der Datei sitemap.xml für die gesamte Website",
        "Włączenie protokołu SSL dla tej witryny": "Aktiviert SSL für diese Website",
        "Włączone (Follow)": "Aktiviert (Follow)",
        "Włączone (Index)": "Aktiviert (Index)",
        "Właściwość ``%0`` aktywnego wpisu": "Eigenschaft ``%0`` des aktiven Eintrags",
        "Właściwości": "Eigenschaften",
        "Własna częstotliwość zmian": "Benutzerdefinierte Änderungshäufigkeit",
        "Własna wartość": "Benutzerdefinierter Wert",
        "Własne polecenie": "Benutzerdefinierter Befehl",
        "Własne reguły": "Benutzerdefinierte Regeln",
        "Własne wymiary": "Benutzerdefinierte Abmessungen",
        "Własny priorytet (od 0 do 1)": "Benutzerdefinierte Priorität (von 0 bis 1)",
        "Wpis został usunięty.": "Der Eintrag wurde gelöscht.",
        "Wpis został zaakceptowany.": "Der Eintrag wurde freigegeben.",
        "Wpis został zaktualizowany.": "Der Eintrag wurde aktualisiert.",
        "Wpisy dotyczą tylko tej witryny i zostaną dodane do robots.txt po zapisaniu. Początkowe reguły dotyczą User-agent: *. Dla konkretnego robota dodaj osobną sekcję User-agent. Puste pole zachowuje domyślny plik.": "Die Einträge gelten nur für diese Website und werden nach dem Speichern zu robots.txt hinzugefügt. Die anfänglichen Regeln gelten für User-agent: *. Für einen bestimmten Bot fügen Sie einen eigenen Abschnitt User-agent hinzu. Ein leeres Feld behält die Standarddatei bei.",
        "Wpisy zostały usunięte.": "Die Einträge wurden gelöscht.",
        "Wpisy zostały zaakceptowane.": "Die Einträge wurden freigegeben.",
        "Wpisz adres linku...": "Linkadresse eingeben...",
        "Wpisz kod HTML lub skrypt, który ma wyświetlać ten widżet.": "Geben Sie den HTML-Code oder das Skript ein, mit dem dieses Widget angezeigt werden soll.",
        "Wpisz tagi oddzielone przecinkami.": "Geben Sie durch Kommas getrennte Tags ein.",
        "Wprowadź link": "Link eingeben",
        "Wprowadź poprawny obiekt JSON.": "Geben Sie ein gültiges JSON-Objekt ein.",
        "Wskaż stronę docelową i opcjonalne parametry adresu.": "Geben Sie die Zielseite und optionale URL-Parameter an.",
        "Wskazany widget nie jest dynamicznym widgetem z formularzem.": "Das angegebene Widget ist kein dynamisches Widget mit Formular.",
        "Wskazuje robotom wyszukiwarek czy mają indeksować stronę.": "Gibt an, ob Suchmaschinen die Seite indexieren sollen.",
        "Wskazuje robotom wyszukiwarek czy mają podążać za linkami.": "Gibt an, ob Suchmaschinen den Links folgen sollen.",
        "Wspólne": "Gemeinsam",
        "Wstaw do edytora": "In den Editor einfügen",
        "Wstaw do treści": "In den Inhalt einfügen",
        "Wstęp": "Einleitung",
        "Wszystkie": "Alle",
        "Wszystkie kolumny będą wyświetlane jedna pod drugą.": "Alle Spalten werden untereinander angezeigt.",
        "Wszystkie strony wybranej witryny i języka.": "Alle Seiten der ausgewählten Website und Sprache.",
        "Wszystko": "Alles",
        "Wtorek": "Dienstag",
        "Wybierz": "Auswählen",
        "Wybierz adres kanoniczny z listy lub podaj ręcznie.": "Wählen Sie eine kanonische Adresse aus der Liste aus oder geben Sie sie manuell ein.",
        "Wybierz ankietę": "Umfrage auswählen",
        "Wybierz aranżacje": "Layouts auswählen",
        "Wybierz artykuł": "Artikel auswählen",
        "Wybierz autora": "Autor auswählen",
        "Wybierz co najmniej jedną kategorię, do której użytkownik może się zapisać.": "Wählen Sie mindestens eine Kategorie aus, für die sich der Benutzer anmelden kann.",
        "Wybierz czołówkę": "Kopfbereich auswählen",
        "Wybierz datę": "Datum auswählen",
        "Wybierz datę lub wprowadź wartość tekstową": "Wählen Sie ein Datum aus oder geben Sie einen Textwert ein",
        "Wybierz docelowe aranżacje": "Ziellayouts auswählen",
        "Wybierz dokument": "Dokument auswählen",
        "Wybierz domyślną kategorię": "Standardkategorie auswählen",
        "Wybierz etykietę": "Label auswählen",
        "Wybierz formularz": "Formular auswählen",
        "Wybierz gotową czołówkę. Przycisk obok otwiera jej pełną konfigurację.": "Wählen Sie einen fertigen Kopfbereich aus. Über die Schaltfläche daneben können Sie die vollständige Konfiguration öffnen.",
        "Wybierz grupę banerów, której elementy mają pojawić się w tym widżecie.": "Wählen Sie die Bannergruppe aus, deren Elemente in diesem Widget angezeigt werden sollen.",
        "Wybierz istniejącego użytkownika": "Vorhandenen Benutzer auswählen",
        "Wybierz język": "Sprache auswählen",
        "wybierz katalog": "Katalog auswählen",
        "Wybierz kategorie": "Kategorien auswählen",
        "Wybierz listę regulaminów": "Liste der Nutzungsbedingungen auswählen",
        "Wybierz listę stron": "Seitenliste auswählen",
        "Wybierz miejsce dla: %0": "Platz für %0 auswählen",
        "Wybierz odnośnik": "Verweis auswählen",
        "Wybierz plik wideo z repozytorium albo wklej adres materiału.": "Wählen Sie eine Videodatei aus dem Repository aus oder fügen Sie die Medienadresse ein.",
        "Wybierz podpowiedź albo wpisz własne polecenie – zmiana dotyczy wyłącznie zaznaczonego tekstu.": "Wählen Sie einen Vorschlag aus oder geben Sie eine eigene Anweisung ein – die Änderung betrifft nur den ausgewählten Text.",
        "Wybierz pole, żeby przejść do edycji w podglądzie.": "Wählen Sie ein Feld aus, um es in der Vorschau zu bearbeiten.",
        "Wybierz regulamin": "Nutzungsbedingungen auswählen",
        "Wybierz sekcję": "Abschnitt auswählen",
        "Wybierz sekcję, której nazwę chcesz zmienić.": "Wählen Sie den Abschnitt aus, dessen Namen Sie ändern möchten.",
        "Wybierz sposób działania i prezentacji strony.": "Wählen Sie die Funktionsweise und Darstellung der Seite aus.",
        "Wybierz stronę": "Seite auswählen",
        "Wybierz stronę do zatwierdzenia.": "Wählen Sie die zu genehmigende Seite aus.",
        "Wybierz szablon": "Vorlage auswählen",
        "Wybierz szablon...": "Vorlage auswählen...",
        "Wybierz target": "Target auswählen",
        "Wybierz treść": "Inhalt auswählen",
        "Wybierz typ aranżacji": "Layouttyp auswählen",
        "Wybierz typ aranżacji do skonfigurowania.": "Wählen Sie den zu konfigurierenden Layouttyp aus.",
        "Wybierz użytkownika": "Benutzer auswählen",
        "Wybierz widżet": "Widget auswählen",
        "Wybierz widżet, aby sprawdzić jego konfigurację.": "Wählen Sie ein Widget aus, um seine Konfiguration zu überprüfen.",
        "Wybierz wiele": "Mehrere auswählen",
        "Wybierz witrynę": "Website auswählen",
        "Wybierz witrynę i język": "Website und Sprache auswählen",
        "Wybierz z listy": "Aus der Liste auswählen",
        "Wybierz…": "Auswählen…",
        "wybór": "Auswahl",
        "Wybór kategorii jest wymagany": "Die Auswahl einer Kategorie ist erforderlich",
        "Wybór listy stron": "Auswahl der Seitenliste",
        "Wybór strony": "Seitenauswahl",
        "Wybrana ikona powinna być kwadratem.": "Das ausgewählte Symbol muss quadratisch sein.",
        "Wybrane ankiety zostały usunięte.": "Die ausgewählten Umfragen wurden gelöscht.",
        "Wybrane artykuły": "Ausgewählte Artikel",
        "Wybrane artykuły zostały usunięte.": "Die ausgewählten Artikel wurden gelöscht.",
        "Wybrane czołówki zostały usunięte.": "Die ausgewählten Kopfbereiche wurden gelöscht.",
        "Wybrane dokumenty zostały usunięte.": "Die ausgewählten Dokumente wurden gelöscht.",
        "Wybrane etykiety zostały usunięte.": "Die ausgewählten Labels wurden gelöscht.",
        "Wybrane galerie zostały usunięte.": "Die ausgewählten Galerien wurden gelöscht.",
        "Wybrane gazetki zostały usunięte.": "Die ausgewählten Broschüren wurden gelöscht.",
        "Wybrane kategorie zostały usunięte.": "Die ausgewählten Kategorien wurden gelöscht.",
        "Wybrane linki wewnętrzne zostały usunięte.": "Die ausgewählten internen Links wurden gelöscht.",
        "Wybrane linki zostały usunięte.": "Die ausgewählten Links wurden gelöscht.",
        "Wybrane materiały wideo zostały usunięte.": "Die ausgewählten Videos wurden gelöscht.",
        "Wybrane pytania zostały usunięte.": "Die ausgewählten Fragen wurden gelöscht.",
        "Wybrane regulaminy": "Ausgewählte Nutzungsbedingungen",
        "Wybrane rotatory zostały usunięte.": "Die ausgewählten Rotatoren wurden gelöscht.",
        "Wybrane strony": "Ausgewählte Seiten",
        "Wybrane subskrypcje zostały usunięte.": "Die ausgewählten Abonnements wurden gelöscht.",
        "Wybrane top tematy zostały usunięte.": "Die ausgewählten Top-Themen wurden gelöscht.",
        "Wybrane wpisy zostały usunięte.": "Die ausgewählten Einträge wurden gelöscht.",
        "Wybrani autorzy zostali usunięci.": "Die ausgewählten Autoren wurden gelöscht.",
        "Wybranie ankiety jest wymagane": "Die Auswahl einer Umfrage ist erforderlich",
        "Wybranie katalogu jest wymagane": "Die Auswahl eines Verzeichnisses ist erforderlich",
        "Wybranie rotatora jest wymagane": "Die Auswahl eines Rotators ist erforderlich",
        "Wybranie strony jest wymagane": "Die Auswahl einer Seite ist erforderlich",
        "Wybraniue modułu jest wymagane": "Die Auswahl eines Moduls ist erforderlich",
        "Wybraniue sekcji jest wymagane": "Die Auswahl eines Abschnitts ist erforderlich",
        "Wybrano": "Ausgewählt",
        "Wybrano etykietę \"Artykuł sponsorowany\".": "Das Label \"Gesponserter Artikel\" wurde ausgewählt.",
        "Wybrano etykietę \"Opinia\".": "Das Label \"Meinung\" wurde ausgewählt.",
        "Wybrano: {0}": "Ausgewählt: {0}",
        "Wybrany język": "Ausgewählte Sprache",
        "Wybrany szablon": "Ausgewählte Vorlage",
        "Wybrany szablon witryny nie udostępnia żadnego układu.": "Die ausgewählte Website-Vorlage stellt kein Layout bereit.",
        "Wybrany znak zastąpi znacznik separatora | wstawiony w tytule.": "Das ausgewählte Zeichen ersetzt das im Titel eingefügte Trennzeichen |.",
        "Wyczyść": "Leeren",
        "Wyczyść wyszukiwanie": "Suche leeren",
        "Wydajność": "Leistung",
        "Wygenerowane sloty dla widgetów": "Generierte Slots für Widgets",
        "Wygeneruj definicję szablonu": "Vorlagendefinition generieren",
        "Wygeneruj krótki tytuł": "Kurztitel generieren",
        "Wygeneruj obraz z treści artykułu": "Bild aus dem Artikelinhalt generieren",
        "Wygeneruj tytuł": "Titel generieren",
        "Wygeneruj wstęp": "Einleitung generieren",
        "Wygeneruj z nazwy autora": "Aus dem Autorennamen generieren",
        "Wygląd": "Darstellung",
        "Wygląd wiadomości e-mail": "Erscheinungsbild der E-Mail",
        "Wyjaśnij prostym językiem najważniejsze pojęcia z treści": "Erklären Sie die wichtigsten Begriffe aus dem Inhalt in einfacher Sprache",
        "Wykonawca": "Ausführender",
        "Wyłącz cenę": "Preis deaktivieren",
        "Wyłącz cenę z historii": "Preis aus dem Verlauf deaktivieren",
        "Wyłącz komentarze": "Kommentare deaktivieren",
        "Wyłącz skupienie": "Fokus deaktivieren",
        "Wyłącz udostępnianie": "Teilen deaktivieren",
        "Wyłącz wszystkie": "Alle deaktivieren",
        "Wyłącz, aby strona nie była dostępna w witrynie.": "Deaktivieren, damit die Seite auf der Website nicht verfügbar ist.",
        "Wyłącz, aby ukryć widżet na stronie bez usuwania jego ustawień i zawartości.": "Deaktivieren, um das Widget auf der Seite auszublenden, ohne seine Einstellungen und Inhalte zu löschen.",
        "Wyłączona": "Deaktiviert",
        "Wyłączone (NoFollow)": "Deaktiviert (NoFollow)",
        "Wyłączone (NoIndex)": "Deaktiviert (NoIndex)",
        "Wyłączone komentarze": "Kommentare deaktiviert",
        "Wyłączone przez:": "Deaktiviert durch:",
        "Wyłączone udostępnianie": "Teilen deaktiviert",
        "Wyłączono focus widgetu": "Widget-Fokus deaktiviert",
        "Wyłączony autor nie jest widoczny na stronie.": "Ein deaktivierter Autor ist auf der Seite nicht sichtbar.",
        "Wyliczana automatycznie (Omnibus).": "Wird automatisch berechnet (Omnibus).",
        "Wymaga logowania przed wyświetleniem treści witryny.": "Erfordert eine Anmeldung, bevor der Website-Inhalt angezeigt wird.",
        "Wymaga ponownej akceptacji": "Erfordert eine erneute Freigabe",
        "Wymagaj ponownej akceptacji po zmianach": "Erneute Freigabe nach Änderungen verlangen",
        "Wymagane": "Erforderlich",
        "Wymagane jest wybranie sekcji": "Die Auswahl eines Abschnitts ist erforderlich",
        "Wymagane jest wybranie wersji językowej": "Die Auswahl einer Sprachversion ist erforderlich",
        "Wymagane jest wybranie witryny": "Die Auswahl einer Website ist erforderlich",
        "Wymagane jest wybranie zestawu regulaminów": "Die Auswahl eines Regelwerks ist erforderlich",
        "Wymiar": "Maß",
        "Wymiary strony": "Seitengröße",
        "Wyniki": "Ergebnisse",
        "Wyniki ankiety": "Umfrageergebnisse",
        "Wyniki pojawią się po pierwszym oddanym głosie.": "Die Ergebnisse werden nach der ersten abgegebenen Stimme angezeigt.",
        "Wyniki_": "Ergebnisse_",
        "Wypisz najważniejsze wnioski": "Die wichtigsten Erkenntnisse auflisten",
        "Wypisz znalezione błędy bez zmiany treści": "Gefundene Fehler auflisten, ohne den Inhalt zu ändern",
        "Wyrażone zgody": "Erteilte Einwilligungen",
        "Wyróżnia artykuł przy ustalaniu kolejności publikacji.": "Hebt den Artikel bei der Festlegung der Veröffentlichungsreihenfolge hervor.",
        "Wyróżnik artykułu na listingach": "Artikelkennzeichnung in Auflistungen",
        "Wysłane": "Gesendet",
        "Wyślij wiadomość": "Nachricht senden",
        "Wysoki": "Hoch",
        "Wysokość": "Höhe",
        "Wystąpił błąd": "Ein Fehler ist aufgetreten",
        "Wystąpiły błędy w formularzu. Sprawdź wszystkie pola formularza.": "Im Formular sind Fehler aufgetreten. Überprüfen Sie alle Formularfelder.",
        "Wyświetla się, gdy adres nie prowadzi do istniejącej strony. Jest automatycznie ukryta w nawigacji.": "Wird angezeigt, wenn die Adresse zu keiner vorhandenen Seite führt. Sie wird automatisch in der Navigation ausgeblendet.",
        "Wyświetlaj listę artykułów z miniaturką zdjęcia": "Artikelliste mit Vorschaubild anzeigen",
        "Wyświetlaj nazwę widgetu": "Widget-Namen anzeigen",
        "Wyświetlaj opinie z tłem": "Bewertungen mit Hintergrund anzeigen",
        "Wyświetlaj tytuł": "Titel anzeigen",
        "Wyświetlana jako przekreślona.": "Wird durchgestrichen angezeigt.",
        "Wyświetlane na listingu i nad treścią": "In der Auflistung und über dem Inhalt angezeigt",
        "Wyświetlane przy tym artykule": "Bei diesem Artikel angezeigt",
        "Wyświetlany na listingach i w stopce artykułu.": "In Auflistungen und in der Fußzeile des Artikels angezeigt.",
        "Wyświetlenia": "Aufrufe",
        "Wyszukaj": "Suchen",
        "Wyszukaj albo dodaj nową kategorię": "Kategorie suchen oder neue hinzufügen",
        "Wyszukaj albo dodaj nowy tag": "Tag suchen oder neuen hinzufügen",
        "Wyszukaj autora i kliknij plus. Wybrane osoby pojawią się na liście widżetu.": "Suchen Sie nach einem Autor und klicken Sie auf das Pluszeichen. Die ausgewählten Personen erscheinen in der Widget-Liste.",
        "Wyszukaj autora...": "Autor suchen...",
        "Wyszukaj czołówkę...": "Aufmacher suchen...",
        "Wyszukaj czołówkę…": "Aufmacher suchen…",
        "Wyszukaj kategorię": "Kategorie suchen",
        "Wyszukaj kategorię...": "Kategorie suchen...",
        "Wyszukaj regulamin…": "Regelwerk suchen…",
        "Wyszukaj treść": "Inhalt suchen",
        "Wyszukaj widżet": "Widget suchen",
        "Wyszukiwanie zwraca tylko zaakceptowane wersje regulaminów.": "Die Suche liefert nur freigegebene Versionen der Regelwerke.",
        "Wyżej": "Weiter oben",
        "Wznawiam podgląd...": "Vorschau wird fortgesetzt...",
        "Wzór shortcode został usunięty.": "Die Shortcode-Vorlage wurde gelöscht.",
        "Wzór shortcode został zapisany.": "Die Shortcode-Vorlage wurde gespeichert.",
        "Wzory": "Vorlagen",
        "YouTube (ID)": "YouTube (ID)",
        "Z metadanych / generatora": "Aus Metadaten / Generator",
        "Zaakceptowane": "Akzeptiert",
        "Zaakceptowane wersje": "Akzeptierte Versionen",
        "Zaakceptowany": "Akzeptiert",
        "Zaawansowane polecenia": "Erweiterte Befehle",
        "Zaawansowany": "Erweitert",
        "zacznij pisać aby wyszukać ankietę...": "Beginnen Sie zu tippen, um eine Umfrage zu suchen...",
        "zacznij pisać aby wyszukać ankiety...": "Beginnen Sie zu tippen, um Umfragen zu suchen...",
        "zacznij pisać aby wyszukać artykuł...": "Beginnen Sie zu tippen, um einen Artikel zu suchen...",
        "zacznij pisać aby wyszukać autora...": "Beginnen Sie zu tippen, um einen Autor zu suchen...",
        "zacznij pisać aby wyszukać autora…": "Beginnen Sie zu tippen, um einen Autor zu suchen…",
        "zacznij pisać aby wyszukać dokument...": "Beginnen Sie zu tippen, um ein Dokument zu suchen...",
        "zacznij pisać aby wyszukać galerię...": "Beginnen Sie zu tippen, um eine Galerie zu suchen...",
        "zacznij pisać aby wyszukać grupę...": "Beginnen Sie zu tippen, um eine Gruppe zu suchen...",
        "zacznij pisać aby wyszukać kategorię...": "Beginnen Sie zu tippen, um eine Kategorie zu suchen...",
        "zacznij pisać aby wyszukać rotator...": "Beginnen Sie zu tippen, um einen Rotator zu suchen...",
        "zacznij pisać aby wyszukać rotator…": "Beginnen Sie zu tippen, um einen Rotator zu suchen…",
        "zacznij pisać aby wyszukać wideo...": "Beginnen Sie zu tippen, um ein Video zu suchen...",
        "Zacznij pisać, aby wyszukać autora…": "Beginnen Sie zu tippen, um einen Autor zu suchen…",
        "Zacznij pisać, aby wyszukać grupę…": "Beginnen Sie zu tippen, um eine Gruppe zu suchen…",
        "Zacznij pisać, aby wyszukać użytkownika…": "Beginnen Sie zu tippen, um einen Benutzer zu suchen…",
        "Zadaj pytanie lub wpisz polecenie": "Stellen Sie eine Frage oder geben Sie einen Befehl ein",
        "Zaimportowano listę przekierowań.": "Die Weiterleitungsliste wurde importiert.",
        "Zakończone": "Abgeschlossen",
        "Zakres": "Bereich",
        "Załączniki": "Anhänge",
        "Załączniki premium": "Premium-Anhänge",
        "Zamiany zostały zapisane.": "Die Ersetzungen wurden gespeichert.",
        "Zamknięto edytor formularza": "Der Formular-Editor wurde geschlossen",
        "Zamknięto edytor wpisu": "Der Beitragseditor wurde geschlossen",
        "Zamknij": "Schließen",
        "Zamknij edytor": "Editor schließen",
        "Zamknij Live Design": "Live Design schließen",
        "Zamknij panel skrótów albo boczny panel": "Tastenkürzel- oder Seitenleiste schließen",
        "zamówień": "Bestellungen",
        "zamówienia": "Bestellungen",
        "Zamówienia": "Bestellungen",
        "zamówienie": "Bestellung",
        "Zamówienie": "Bestellung",
        "Zamówienie zostało zaktualizowane.": "Die Bestellung wurde aktualisiert.",
        "Zamówiony pakiet": "Bestelltes Paket",
        "Zapisano ustawienia kanałów RSS.": "Die RSS-Kanaleinstellungen wurden gespeichert.",
        "Zapisz": "Speichern",
        "Zapisz aranżację": "Layout speichern",
        "Zapisz i wróć": "Speichern und zurück",
        "Zapisz lub odrzuć zmiany, aby zmienić witrynę.": "Speichern oder verwerfen Sie die Änderungen, um die Website zu wechseln.",
        "Zapisz ustawienia": "Einstellungen speichern",
        "Zapisz zmiany": "Änderungen speichern",
        "Zaplanowana zmiana ceny": "Geplante Preisänderung",
        "Zaplanowane": "Geplant",
        "Zaproponuj trzy śródtytuły dla tej treści": "Drei Zwischenüberschriften für diesen Inhalt vorschlagen",
        "Zaproponuj tytuł i lead dla tej treści": "Einen Titel und Vorspann für diesen Inhalt vorschlagen",
        "Zapytanie EQL": "EQL-Abfrage",
        "Zarejestrowani użytkownicy": "Registrierte Benutzer",
        "Zarządzaj dostępem do strony w panelu.": "Verwalten Sie den Seitenzugriff im Dashboard.",
        "Zarządzaj dostępem do tej witryny w panelu administracyjnym.": "Verwalten Sie den Zugriff auf diese Website im Administrationsbereich.",
        "Zarządzaj kategoriami": "Kategorien verwalten",
        "Zarządzanie": "Verwaltung",
        "Zarządzanie witrynami": "Website-Verwaltung",
        "Zasady zgłaszania treści przez użytkowników.": "Regeln für das Melden von Inhalten durch Benutzer.",
        "Zasoby": "Ressourcen",
        "Zastąp": "Ersetzen",
        "Zastąp fragment": "Abschnitt ersetzen",
        "Zastosuj": "Anwenden",
        "Zatwierdź": "Bestätigen",
        "Zawartość sekcji została zastąpiona w wybranych aranżacjach.": "Der Inhalt des Abschnitts wurde in den ausgewählten Layouts ersetzt.",
        "Zawiera sekcje": "Enthält Abschnitte",
        "Zawierające jeden z wybranych tagów": "Enthält eines der ausgewählten Tags",
        "Zawsze": "Immer",
        "Zaznacz tekst, aby wykonać operację AI.": "Markieren Sie Text, um eine KI-Operation auszuführen.",
        "Zaznacz wszystkie": "Alle auswählen",
        "Zaznaczone": "Ausgewählt",
        "Zaznaczony fragment": "Markierter Textabschnitt",
        "Zbuduj zawartość strony z sekcji i elementów.": "Erstellen Sie den Seiteninhalt aus Abschnitten und Elementen.",
        "Zdjęcia": "Fotos",
        "Zdjęcia dostępne w ramach treści premium. Kolejność zmienisz przeciąganiem.": "Fotos, die im Rahmen von Premium-Inhalten verfügbar sind. Ändern Sie die Reihenfolge durch Ziehen.",
        "Zdjęcia galerii": "Galeriefotos",
        "Zdjęcie": "Foto",
        "Zdjęcie dla tabletów": "Foto für Tablets",
        "Zdjęcie dla urządzeń mobilnych": "Foto für Mobilgeräte",
        "Zdjęcie główne": "Hauptfoto",
        "Zdjęcie główne nie jest widoczne w przypadku zaznaczenia opcji \"Tylko treść artykułu\".": "Das Hauptfoto ist nicht sichtbar, wenn die Option \"Nur Artikelinhalt\" ausgewählt ist.",
        "Zdjęcie na okładce": "Titelfoto",
        "Zdjęcie w tle": "Hintergrundbild",
        "Zdjęcie/ikonka": "Foto/Ikone",
        "Zduplikowano widget": "Widget dupliziert",
        "Zestaw": "Set",
        "Zestaw niestandardowy": "Benutzerdefiniertes Set",
        "Zestaw regulaminów prezentowany przy zapisie do subskrypcji.": "Set von Nutzungsbedingungen, das bei der Anmeldung zum Abonnement angezeigt wird.",
        "Zestaw został dodany.": "Das Set wurde hinzugefügt.",
        "Zestaw został zaktualizowany.": "Das Set wurde aktualisiert.",
        "Zewnętrzne skrypty statystyk": "Externe Statistikskripte",
        "Zewnętrzne skrypty targetujące": "Externe Targeting-Skripte",
        "Zewnętrzny": "Extern",
        "Zewnętrzny serwis": "Externer Dienst",
        "Zezwalaj na odkrywanie treści": "Auffindbarkeit von Inhalten erlauben",
        "Zezwalaj na używanie treści przez AI": "Die Nutzung von Inhalten durch KI erlauben",
        "Zgłaszanie": "Meldungen",
        "Zgłaszanie komentarzy": "Kommentare melden",
        "Zgłaszanie tylko po zalogowaniu": "Melden nur nach Anmeldung",
        "zgłoszeń": "Meldungen",
        "Zgłoszenia": "Meldungen",
        "Zmiana formularza nie będzie możliwa po zapisaniu shortcode.": "Das Formular kann nach dem Speichern des Shortcodes nicht mehr geändert werden.",
        "Zmiana nazwy nie zmienia identyfikatora sekcji ani jej umiejscowienia.": "Eine Namensänderung ändert weder die Abschnitts-ID noch dessen Position.",
        "Zmiana przenosi kategorię wraz z podkategoriami.": "Die Änderung verschiebt die Kategorie zusammen mit ihren Unterkategorien.",
        "Zmiana symbolu powoduje również zmianę adresu URL.": "Eine Änderung des Symbols führt auch zu einer Änderung der URL.",
        "Zmiana trybu układu": "Layoutmodus ändern",
        "Zmiana została zapisana.": "Die Änderung wurde gespeichert.",
        "Zmiany w tym widoku bezpośrednio wpływają na działanie aplikacji frontend. Upewnij się, że modyfikacje są przemyślane i uzasadnione.": "Änderungen in dieser Ansicht wirken sich direkt auf die Funktionsweise der Frontend-Anwendung aus. Stellen Sie sicher, dass die Änderungen gut durchdacht und begründet sind.",
        "Zmiany widżetu będą widoczne również w tych aranżacjach.": "Änderungen am Widget werden auch in diesen Layouts sichtbar sein.",
        "Zmiany wpływają na frontend": "Änderungen wirken sich auf das Frontend aus",
        "Zmiany zostały zapisane.": "Die Änderungen wurden gespeichert.",
        "Zmień daty publikacji": "Veröffentlichungsdaten ändern",
        "Zmień nazwę": "Namen ändern",
        "Zmień nazwę katalogu": "Ordnernamen ändern",
        "Zmień nazwę kategorii": "Kategorienamen ändern",
        "Zmień tonalność i dodaj bezpośredni zwrot do czytelnika": "Tonalität ändern und direkte Ansprache der Lesenden hinzufügen",
        "Zmień tonalność zaznaczonego fragmentu i uprość zdania": "Tonalität des markierten Abschnitts ändern und Sätze vereinfachen",
        "Zmień tonalność zaznaczonego fragmentu, pozostawiając terminologię": "Tonalität des markierten Abschnitts ändern und dabei die Terminologie beibehalten",
        "Zmień tonalność zaznaczonego fragmentu, zachowując treść": "Tonalität des markierten Abschnitts ändern und dabei den Inhalt beibehalten",
        "Zmieną %HEAD_TITLE% można wykorzystać w innych polach tekstowych.": "Die Variable %HEAD_TITLE% kann in anderen Textfeldern verwendet werden.",
        "Zmieniono kolejność widgetów": "Die Reihenfolge der Widgets wurde geändert",
        "Zmienne": "Variablen",
        "Znajdź typ widgetu...": "Widget-Typ finden...",
        "Znajdź typ widżetu": "Widget-Typ finden",
        "Znajdź widżet": "Widget finden",
        "Znajdź widżet…": "Widget finden…",
        "znaków": "Zeichen",
        "Zobacz przed opublikowaniem": "Vor der Veröffentlichung anzeigen",
        "Zrezygnowano": "Abgebrochen",
        "Źródło danych": "Datenquelle",
        "Źródło URL": "URL-Quelle",
        "Źródło wideo": "Videoquelle",
        "Źródło wideo premium": "Premium-Videoquelle",
        "Zwięzła wersja do kafelków i list artykułów.": "Kompakte Version für Kacheln und Artikellisten.",
        "Zwiń panel podglądu": "Vorschaupanel einklappen",
        "Zwrot do nadawcy": "An den Absender zurücksenden"
    }
};
